import mn, { memo as Me, useState as Z, useMemo as B, useCallback as F, useEffect as J, useContext as Ie, useReducer as fn, useRef as rt, createContext as vs } from "react";
import { Button as de, Icon as oe, AnalysisIcon as qn, Input as Le, useNotifications as ot, Grid as T, Box as ge, Typography as ye, Radio as At, Tooltip as mt, ContentBlock as Wt, CheckboxCell as It, Table as mr, Checkbox as fr, Block as Cn, EmptyTableStub as _s, ButtonGroup as Os, Select as hn, Spinner as ve, Divider as En, SEARCH_PRECISION_OPTIONS as jt, Autocomplete as Qt, SearchPrecision as Ns, Dialog as bs, DialogTitle as Rs, DialogContent as As, DialogActions as js, AISpinner as Cr } from "@prometheus/components";
import { ModalContext as He, useSimpleImport as ws, useExport as Ps, useSectionsNew as Ds, useGenerate as Ls, useFilterOptions as Ms, useAvailableModels as Us, getOverlayHistoryCount as Xt, goBackOverlayHistory as ks, pushOverlayHistoryState as $s, subscribeOverlayHistoryPop as Bs, useEntityNew as Ws, useRequest as Vs, DialogContext as Fs, useAiEventsApi as zs, useIntervalWithCondition as Gs } from "@prometheus/hooks";
import { api as k, getSortDirection as qe, createFiltersPanelListConfig as Ys, createCrudMethodsListConfig as Hs, createHeadersFromMetadataAttributes as qs, createSortingMethodListConfig as Js, getConceptSetById as tn, truncate as Ks, convertLegacyConceptsToExtendedConcepts as ft, convertExtendedToLegacyConcepts as wt, getNumberUUID as Qs, isEmpty as bt, getReducerWithProduce as gn, keyBy as Xs, getCodeLanguageByFileExtension as Jn, isEqual as Pt, getUUID as Zs, createBreadcrumbsEntityConfig as eo, isAiGeneratedMetadata as nn, isAiStatusMetadata as to, parseStatistics as no, formatFilterListNoFiql as ro, getPublishOriginBreadcrumb as so, isAiMetadataName as oo, getDerivedObjectsCount as ao } from "@prometheus/utils";
import { TypesOfContainer as b, NameConflictResolution as te, EntityIconNames as je, iconAnalyses as rn, FileExtension as ke, ImportAtlasAsset as ht, TypesOfSave as Ve, containerTypes as io, ConceptSetSectionTabs as Pe, TypesOfIncluded as _e, EntityTypes as Rt, mapStandardConceptTypes as co } from "@prometheus/enums";
import { ICON_COLUMN as lo, ID_COLUMN as uo, NAME_COLUMN as hr, CREATED_COLUMN as po, UPDATED_COLUMN as mo, AUTHOR_COLUMN as fo, EntityTypeCell as $e, EntityImport as Co, FileContentType as pt, ImportMultipleSource as Sn, NameWithAliasCell as ho, ActionCell as Eo, FormElement as we, FormActionsContainer as Er, SubModuleDescriptionBlock as go, TabWithCounter as Ae, TabsNavigationNew as xn, SpinnerWidgetContainer as De, CodeEditor as vt, SecondaryContentWrapper as Be, Section as So, ExportMultipleSource as gr, PageList as Sr, Statistics as xo, useIsLibraryDataSteward as yo, useArchiveLibraryMember as To, ErrorPage as Kn, Versions as Io, MetaAttributes as Qn, NestedInfoWrapper as vo, ConceptSetBaseInfo as _o, PublishEntity as Oo, ConfirmationDialog as No } from "@prometheus/features";
import Ce from "@emotion/styled";
import { useNavigate as Vt, Link as bo, useLocation as xr, Routes as yr, Route as Te, useParams as Tr, useSearchParams as Ro, Navigate as Xn } from "react-router-dom";
import { Status as P, AiSuggestionStatus as et, EntityActions as Ao, ListActions as jo } from "@prometheus/types";
import { getSummary as wo, addCompareItem as Po, setBreadcrumbs as Do } from "@prometheus/redux";
import { useDispatch as Ir, useSelector as vr } from "react-redux";
var sn = { exports: {} }, lt = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zn;
function Lo() {
  if (Zn) return lt;
  Zn = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(s, a, o) {
    var i = null;
    if (o !== void 0 && (i = "" + o), a.key !== void 0 && (i = "" + a.key), "key" in a) {
      o = {};
      for (var l in a)
        l !== "key" && (o[l] = a[l]);
    } else o = a;
    return a = o.ref, {
      $$typeof: e,
      type: s,
      key: i,
      ref: a !== void 0 ? a : null,
      props: o
    };
  }
  return lt.Fragment = t, lt.jsx = n, lt.jsxs = n, lt;
}
var dt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var er;
function Mo() {
  return er || (er = 1, process.env.NODE_ENV !== "production" && function() {
    function e(C) {
      if (C == null) return null;
      if (typeof C == "function")
        return C.$$typeof === ie ? null : C.displayName || C.name || null;
      if (typeof C == "string") return C;
      switch (C) {
        case D:
          return "Fragment";
        case N:
          return "Profiler";
        case L:
          return "StrictMode";
        case g:
          return "Suspense";
        case v:
          return "SuspenseList";
        case Y:
          return "Activity";
      }
      if (typeof C == "object")
        switch (typeof C.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), C.$$typeof) {
          case x:
            return "Portal";
          case $:
            return (C.displayName || "Context") + ".Provider";
          case M:
            return (C._context.displayName || "Context") + ".Consumer";
          case y:
            var j = C.render;
            return C = C.displayName, C || (C = j.displayName || j.name || "", C = C !== "" ? "ForwardRef(" + C + ")" : "ForwardRef"), C;
          case A:
            return j = C.displayName || null, j !== null ? j : e(C.type) || "Memo";
          case U:
            j = C._payload, C = C._init;
            try {
              return e(C(j));
            } catch {
            }
        }
      return null;
    }
    function t(C) {
      return "" + C;
    }
    function n(C) {
      try {
        t(C);
        var j = !1;
      } catch {
        j = !0;
      }
      if (j) {
        j = console;
        var z = j.error, G = typeof Symbol == "function" && Symbol.toStringTag && C[Symbol.toStringTag] || C.constructor.name || "Object";
        return z.call(
          j,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          G
        ), t(C);
      }
    }
    function s(C) {
      if (C === D) return "<>";
      if (typeof C == "object" && C !== null && C.$$typeof === U)
        return "<...>";
      try {
        var j = e(C);
        return j ? "<" + j + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function a() {
      var C = K.A;
      return C === null ? null : C.getOwner();
    }
    function o() {
      return Error("react-stack-top-frame");
    }
    function i(C) {
      if (S.call(C, "key")) {
        var j = Object.getOwnPropertyDescriptor(C, "key").get;
        if (j && j.isReactWarning) return !1;
      }
      return C.key !== void 0;
    }
    function l(C, j) {
      function z() {
        W || (W = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          j
        ));
      }
      z.isReactWarning = !0, Object.defineProperty(C, "key", {
        get: z,
        configurable: !0
      });
    }
    function p() {
      var C = e(this.type);
      return Q[C] || (Q[C] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), C = this.props.ref, C !== void 0 ? C : null;
    }
    function c(C, j, z, G, me, pe, u, ne) {
      return z = pe.ref, C = {
        $$typeof: h,
        type: C,
        key: j,
        props: pe,
        _owner: me
      }, (z !== void 0 ? z : null) !== null ? Object.defineProperty(C, "ref", {
        enumerable: !1,
        get: p
      }) : Object.defineProperty(C, "ref", { enumerable: !1, value: null }), C._store = {}, Object.defineProperty(C._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(C, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(C, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: u
      }), Object.defineProperty(C, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ne
      }), Object.freeze && (Object.freeze(C.props), Object.freeze(C)), C;
    }
    function d(C, j, z, G, me, pe, u, ne) {
      var ee = j.children;
      if (ee !== void 0)
        if (G)
          if (R(ee)) {
            for (G = 0; G < ee.length; G++)
              f(ee[G]);
            Object.freeze && Object.freeze(ee);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else f(ee);
      if (S.call(j, "key")) {
        ee = e(C);
        var H = Object.keys(j).filter(function(Ee) {
          return Ee !== "key";
        });
        G = 0 < H.length ? "{key: someKey, " + H.join(": ..., ") + ": ...}" : "{key: someKey}", ue[ee + G] || (H = 0 < H.length ? "{" + H.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          G,
          ee,
          H,
          ee
        ), ue[ee + G] = !0);
      }
      if (ee = null, z !== void 0 && (n(z), ee = "" + z), i(j) && (n(j.key), ee = "" + j.key), "key" in j) {
        z = {};
        for (var I in j)
          I !== "key" && (z[I] = j[I]);
      } else z = j;
      return ee && l(
        z,
        typeof C == "function" ? C.displayName || C.name || "Unknown" : C
      ), c(
        C,
        ee,
        pe,
        me,
        a(),
        z,
        u,
        ne
      );
    }
    function f(C) {
      typeof C == "object" && C !== null && C.$$typeof === h && C._store && (C._store.validated = 1);
    }
    var E = mn, h = Symbol.for("react.transitional.element"), x = Symbol.for("react.portal"), D = Symbol.for("react.fragment"), L = Symbol.for("react.strict_mode"), N = Symbol.for("react.profiler"), M = Symbol.for("react.consumer"), $ = Symbol.for("react.context"), y = Symbol.for("react.forward_ref"), g = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), A = Symbol.for("react.memo"), U = Symbol.for("react.lazy"), Y = Symbol.for("react.activity"), ie = Symbol.for("react.client.reference"), K = E.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, S = Object.prototype.hasOwnProperty, R = Array.isArray, q = console.createTask ? console.createTask : function() {
      return null;
    };
    E = {
      react_stack_bottom_frame: function(C) {
        return C();
      }
    };
    var W, Q = {}, he = E.react_stack_bottom_frame.bind(
      E,
      o
    )(), V = q(s(o)), ue = {};
    dt.Fragment = D, dt.jsx = function(C, j, z, G, me) {
      var pe = 1e4 > K.recentlyCreatedOwnerStacks++;
      return d(
        C,
        j,
        z,
        !1,
        G,
        me,
        pe ? Error("react-stack-top-frame") : he,
        pe ? q(s(C)) : V
      );
    }, dt.jsxs = function(C, j, z, G, me) {
      var pe = 1e4 > K.recentlyCreatedOwnerStacks++;
      return d(
        C,
        j,
        z,
        !0,
        G,
        me,
        pe ? Error("react-stack-top-frame") : he,
        pe ? q(s(C)) : V
      );
    };
  }()), dt;
}
process.env.NODE_ENV === "production" ? sn.exports = Lo() : sn.exports = Mo();
var r = sn.exports;
const tr = (e, t = te.CREATE_NEW_OBJECT) => `${e}?resolution=${encodeURIComponent(t)}`, Zt = {}, Uo = (e) => e.includes("/copy/") ? "copy" : e.includes("/import/") ? "import" : "default", ko = (e) => {
  switch (e) {
    case te.COPY:
      return Array.from(/* @__PURE__ */ new Set([e, "COPY"]));
    case te.CREATE_NEW_VERSION:
      return Array.from(
        /* @__PURE__ */ new Set([
          "NEW_VERSION",
          e,
          "CREATE_NEW_VERSION",
          "create_new_version",
          "create-new-version"
        ])
      );
    case te.CREATE_NEW_OBJECT:
    default:
      return Array.from(
        /* @__PURE__ */ new Set([
          "NEW_OBJECT",
          e,
          "CREATE_NEW_OBJECT",
          "CREATE_NEW",
          "create_new",
          "create-new"
        ])
      );
  }
}, Et = (e, t, n = te.CREATE_NEW_OBJECT) => {
  const s = Uo(e), a = Zt[s], o = s !== "import";
  if (o && a === null)
    return k.post(e, t);
  if (o && typeof a == "string")
    return k.post(tr(e, a), t).catch((p) => {
      var c;
      if (((c = p == null ? void 0 : p.response) == null ? void 0 : c.status) === 400)
        return delete Zt[s], Et(e, t, n);
      throw p;
    });
  const i = [
    ...ko(n),
    void 0
  ], l = (p) => {
    const c = i[p], d = c ? tr(e, c) : e;
    return k.post(d, t).then((f) => (Zt[s] = c ?? null, f)).catch((f) => {
      var E;
      if (((E = f == null ? void 0 : f.response) == null ? void 0 : E.status) === 400 && p < i.length - 1)
        return l(p + 1);
      throw f;
    });
  };
  return l(0);
}, _r = (e, t) => {
  const n = encodeURIComponent(e), s = t ? `&entityId=${encodeURIComponent(t)}` : "";
  return `name=${n}${s}`;
}, Or = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: s, query: a } = e, o = qe(s), i = `/conceptset/list?size=${n || ""}&page=${t || ""}&sort=${o}&${a || ""}`;
  return k.get(i);
}, Nr = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: s, query: a } = e, o = qe(s), i = `/workspace/concept-sets/list?size=${n || ""}&page=${t || ""}&sort=${o}&${a || ""}`;
  return k.get(i);
}, br = (e) => {
  const { pageNumber: t, pageSize: n, sortBy: s, query: a } = e, o = qe(s), i = `/library/concept-sets/list?size=${n || ""}&page=${t || ""}&sort=${o}&${a || ""}`;
  return k.get(i);
}, Rr = (e, t) => {
  const { pageNumber: n, pageSize: s, sortBy: a, query: o } = t, i = qe(a), l = `/studies/${e}/concept-sets/list?size=${s || ""}&page=${n || ""}&sort=${i}&${o || ""}`;
  return k.get(l);
}, $o = (e) => {
  const t = `/conceptset/filter?${e}`;
  return k.get(t);
}, Bo = () => k.get("/conceptset/sorts"), Wo = () => k.get("/workspace/concept-sets/sorts"), Vo = (e) => k.get(`/conceptset/${e}/usage/sorts`), Fo = (e) => {
  const t = `/workspace/concept-sets/filter?${e}`;
  return k.get(t);
}, nr = (e, t) => {
  const n = `/conceptset/metadata-value/${e}/copy`;
  return k.post(n, t);
}, zo = (e, t) => {
  const n = `/studies/${t}/concept-sets/filter?${e}`;
  return k.get(n);
}, Go = (e) => {
  const t = `/library/concept-sets/filter?${e}`;
  return k.get(t);
}, Ft = (e) => k.get(`/conceptset/${e}`), Ar = (e, t) => {
  const { pageNumber: n, pageSize: s, sortBy: a, query: o } = t, i = qe(a), l = `/conceptset/${e}/usage/list?size=${s || ""}&page=${n || 0}&sort=${i}&${o || ""}`;
  return k.get(l);
}, Yo = (e, t) => {
  const n = `/conceptset/${t}/usage/filter?${e}`;
  return k.get(n);
}, jr = (e) => k.delete(`/conceptset/${e}`), yn = (e, t) => k.patch(`/conceptset/${e}`, t), zt = (e) => k.post("/workspace/concept-sets", e), wr = (e, t, n = te.COPY) => Et(
  `/workspace/concept-sets/copy/${e}`,
  t ? { name: t } : {},
  n
), Tn = (e, t) => k.post(`/studies/${e}/concept-sets`, t), Pr = (e, t, n, s = te.COPY) => Et(
  `/studies/${e}/concept-sets/copy/${t}`,
  n ? { name: n } : {},
  s
), Ho = (e, t) => t !== "new" ? yn(t, e) : zt(e), qo = (e, t, n) => t !== "new" ? yn(t, e) : Tn(n, e), Dr = (e, t) => k.post(`/conceptset/${e}/included/total`, t), Lr = (e, t) => k.post(`/conceptset/${e}/included-source-code/total`, t), Mr = (e, t, n, s) => {
  const { pageNumber: a, pageSize: o, sortBy: i, query: l } = t, p = qe(i), c = `/conceptset/${n}/${e}/list?size=${o || ""}&page=${a || ""}&sort=${p}` + (l ? `&${l}` : "");
  return k.post(c, s);
}, Ur = (e, t, n, s) => {
  const { pageNumber: a, pageSize: o, sortBy: i, query: l } = t, p = qe(i), c = `/conceptset/${n}/${e}/filter?size=${o || ""}&page=${a || ""}&sort=${p}` + (l ? `&${l}` : "");
  return k.post(c, s);
}, Jo = (e) => k.get(`/conceptset/${e}/versions?size=10000`), kr = (e) => k.get(`/conceptset/version/${e}`), Ko = (e) => k.post("/library/concept-set/invites", e), Dt = (e, t) => {
  let n = "";
  e && t && (n += `?size=1000000&page=0&${e}=${t}`);
  const s = `/conceptset/metadata-value/list${n}`;
  return k.get(s);
}, on = (e) => k.post("/conceptset/metadata-value", e), an = (e, t) => {
  const n = `/conceptset/metadata-value/${t}`;
  return k.put(n, e);
}, rr = (e) => {
  const t = `/conceptset/metadata-value/${e}`;
  return k.delete(t);
}, Qo = (e, t, n, s) => k.post(`/atlas/${e}/assets/${t}/export?id=${n}&name=${s}`), Xo = (e) => k.get(`/conceptset/${e}/summary`), Zo = (e, t) => k.patch(`/conceptset/${e}`, t), ea = (e = "", t) => {
  {
    const n = e.replace(/^&/, ""), s = `/admin/metadata-attribute/list${n ? `?${n}` : ""}`;
    return k.get(s);
  }
}, ta = (e, t, n = te.CREATE_NEW_OBJECT) => Et(
  `/workspace/concept-sets/import/${e}`,
  t,
  n
), na = (e, t, n, s = te.CREATE_NEW_OBJECT) => Et(
  `/studies/${e}/concept-sets/import/${t}`,
  n,
  s
), ra = (e, t) => k.get(
  `/workspace/concept-sets/check-name?${_r(e, t)}`
), sa = (e, t, n) => k.get(
  `/studies/${e}/concept-sets/check-name?${_r(
    t,
    n
  )}`
), $r = (e, t, n, s) => {
  switch (e) {
    case b.STUDY:
      if (!n)
        throw new Error("Study parentId is required for name check.");
      return sa(n, t, s);
    case b.WORKSPACE:
    default:
      return ra(t, s);
  }
}, sr = (e) => k.get(`/conceptset/suggestion/${e}/status`), Br = (e) => k.get(`/conceptset/${e}/derived-stats`), oa = (e) => {
  const { title: t, onClick: n, dense: s } = e;
  return /* @__PURE__ */ r.jsx(
    de,
    {
      size: s ? "small" : "medium",
      fullWidth: !1,
      variant: "outlined",
      sx: { borderColor: "borderColor.main" },
      onClick: n,
      name: "importButton",
      startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "import" }),
      children: t
    }
  );
}, Lt = (e, t) => Hs(
  e,
  t,
  Or,
  jr,
  Rr,
  Nr,
  br
), Mt = (e, t) => Ys(
  e,
  t,
  $o,
  zo,
  Fo,
  Go
), aa = (e) => Js(e, {
  getSorting: Bo,
  getSortingWorkspace: Wo
}), st = (e, t) => {
  switch (e) {
    case b.WORKSPACE:
      return (n, s) => zt(n);
    case b.STUDY:
      return (n, s) => Tn(t, n);
  }
}, In = (e, t) => {
  switch (e) {
    case b.WORKSPACE:
      return (n, s, a = te.CREATE_NEW_OBJECT) => ta(n, s, a);
    case b.STUDY:
      return (n, s, a = te.CREATE_NEW_OBJECT) => na(t, n, s, a);
  }
}, ia = (e, t, n, s, a) => {
  const o = ["workspace", "study-manager"], i = ["cohorts", "concept-sets", "analyses"], l = (x) => {
    const D = String(x || "").trim(), N = D.split(/[?#]/)[0].replace(/^\/+|\/+$/g, "").split("/").filter(Boolean), M = N.map((g) => g.toLowerCase()), $ = M.findIndex(
      (g) => i.includes(g)
    );
    if ($ >= 0) {
      const g = M[$], v = N[$ + 1] || "";
      return {
        entity: g,
        entityId: v
      };
    }
    return {
      entity: void 0,
      entityId: (o.includes(M[0]) && N[1] ? N[1] : N[0]) || D
    };
  }, { entity: p, entityId: c } = l(e), d = String(t || "").trim().toUpperCase().replace(/[\s-]+/g, "_"), f = String(n || "").trim().toUpperCase().replace(/[\s-]+/g, "_"), E = s === b.WORKSPACE ? "/workspace" : `/study-manager/${a}`, h = (() => {
    var x;
    return p || (f.includes("COHORT") ? "cohorts" : f.includes("CONCEPT_SET") ? "concept-sets" : f.includes("ANALYSIS") ? "analyses" : d.includes("COHORT") ? "cohorts" : d.includes("CONCEPT_SET") ? "concept-sets" : (d === "ANALYSIS" || d.endsWith("_ANALYSIS") || (x = rn) != null && x[d] && d !== "COHORT", "analyses"));
  })();
  return `${E}/${h}/${c}`;
}, Gt = [
  lo({
    id: "typeIcon",
    accessorFn: (e) => e.type || je.CONCEPT_SET,
    cell: $e
  }),
  uo(),
  hr(),
  po(),
  mo(),
  fo()
], ca = ({
  metaAttributes: e = []
} = {}) => [
  ...Gt,
  ...qs(e, !0)
], or = (e) => String(e || "").trim().toUpperCase().replace(/[\s-]+/g, "_"), la = ({ row: e }) => {
  var s, a, o, i;
  const t = or((s = e == null ? void 0 : e.original) == null ? void 0 : s.supertype), n = or((a = e == null ? void 0 : e.original) == null ? void 0 : a.type);
  return t === "COHORT" ? /* @__PURE__ */ r.jsx($e, { value: je.COHORT }) : t === "CONCEPT_SET" ? /* @__PURE__ */ r.jsx($e, { value: je.CONCEPT_SET }) : t === "ANALYSIS" ? (o = rn) != null && o[n] ? /* @__PURE__ */ r.jsx(qn, { value: n }) : /* @__PURE__ */ r.jsx($e, { value: je.ANALYSIS }) : (i = rn) != null && i[n] ? /* @__PURE__ */ r.jsx(qn, { value: n }) : n === "COHORT" ? /* @__PURE__ */ r.jsx($e, { value: je.COHORT }) : n === "CONCEPT_SET" ? /* @__PURE__ */ r.jsx($e, { value: je.CONCEPT_SET }) : /* @__PURE__ */ r.jsx($e, { value: je.ANALYSIS });
}, da = [
  {
    header: "",
    accessorFn: (e) => e.type || e.supertype,
    id: "type",
    cell: la,
    size: 40,
    enableResizing: !1,
    meta: {
      columnType: "action"
    }
  },
  hr()
], ua = [
  {
    Component: Le,
    name: "name",
    label: "Name",
    type: "text"
  },
  {
    Component: Le,
    name: "description",
    label: "Description",
    type: "text",
    multiline: !0,
    minRows: 2,
    maxRows: 10
  }
], pa = "atlas", ma = "Error! Name is already used by another object.", fa = "Unable to validate name uniqueness. Please try again.", Ca = (e) => typeof e == "boolean" ? e : !e || typeof e != "object" ? !0 : typeof e.available == "boolean" ? e.available : typeof e.isAvailable == "boolean" ? e.isAvailable : typeof e.success == "boolean" ? e.success : typeof e.result == "boolean" ? e.result : typeof e.unique == "boolean" ? e.unique : typeof e.isUnique == "boolean" ? e.isUnique : typeof e.valid == "boolean" ? e.valid : typeof e.isValid == "boolean" ? e.isValid : typeof e.exists == "boolean" ? !e.exists : typeof e.duplicate == "boolean" ? !e.duplicate : typeof e.conflict == "boolean" ? !e.conflict : typeof e.used == "boolean" ? !e.used : !0, vn = Me(
  (e) => {
    const {
      onChange: t,
      onClose: n,
      createMethod: s,
      typeContainer: a,
      parentId: o,
      resolution: i = te.CREATE_NEW_OBJECT,
      onResolutionChange: l
    } = e, { enqueueSnackbar: p } = ot(), [c, d] = Z(!1), [f, E] = Z(""), [h, x] = Z(""), D = B(() => ua, []), L = i === te.CREATE_NEW_OBJECT, N = F(() => {
      E("");
    }, []);
    J(() => {
      L || N();
    }, [L, N]);
    const M = F(
      async (A) => {
        var K, S, R, q;
        d(!0);
        const U = ((K = A.name) == null ? void 0 : K.trim()) || "";
        if (L)
          try {
            const W = await $r(
              a,
              U,
              o
            );
            if (!Ca(W)) {
              E(
                (W == null ? void 0 : W.message) || ma
              ), d(!1);
              return;
            }
            N();
          } catch (W) {
            E(
              ((R = (S = W == null ? void 0 : W.response) == null ? void 0 : S.data) == null ? void 0 : R.message) || fa
            ), d(!1);
            return;
          }
        let Y;
        try {
          Y = JSON.parse(
            A.expression || ""
          );
        } catch {
          d(!1), p({
            message: "Imported concept set is invalid!",
            variant: "error"
          });
          return;
        }
        const ie = Y.items || ((q = Y.expression) == null ? void 0 : q.items);
        if (!ie) {
          d(!1), p({
            message: "Imported concept set is invalid!",
            variant: "error"
          });
          return;
        }
        try {
          const W = await s(
            pa,
            {
              name: U,
              description: A.description,
              expression: {
                items: ie
              }
            },
            i
          );
          t(W);
        } catch {
          d(!1), p({
            message: "Oops, something went wrong!!!",
            variant: "error"
          });
        }
      },
      [
        s,
        p,
        L,
        t,
        o,
        N,
        i,
        a
      ]
    ), $ = !!l, y = l || ((A) => {
    });
    return /* @__PURE__ */ r.jsx(T, { container: !0, children: /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
      Co,
      {
        onSubmit: M,
        codeKey: "expression",
        nameKey: "name",
        editorTitle: "Concept Set Expression JSON",
        editorHeight: "53vh",
        fields: D,
        isLoading: c,
        fileExtension: ke.JSON,
        contentType: pt.APPLICATION_JSON,
        onCancel: n,
        submitButtonText: "Import",
        isSubmitDisabled: L && !!f && h.trim().length > 0,
        onFieldValueChange: (A, U) => {
          A === "name" && (x(U), N());
        },
        fieldErrors: {
          name: f
        },
        footerStart: $ ? /* @__PURE__ */ r.jsxs(
          ge,
          {
            display: "flex",
            alignItems: "center",
            columnGap: 1.5,
            flexWrap: "nowrap",
            sx: { maxWidth: "100%", overflowX: "auto", py: 0.5 },
            children: [
              /* @__PURE__ */ r.jsx(ye, { variant: "caption", sx: { whiteSpace: "nowrap" }, children: "Select conflict resolution method:" }),
              /* @__PURE__ */ r.jsxs(
                ge,
                {
                  display: "flex",
                  alignItems: "center",
                  columnGap: 1.5,
                  sx: { whiteSpace: "nowrap" },
                  children: [
                    /* @__PURE__ */ r.jsxs(ge, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
                      /* @__PURE__ */ r.jsx(
                        At,
                        {
                          checked: i === te.CREATE_NEW_VERSION,
                          onChange: () => y(
                            te.CREATE_NEW_VERSION
                          ),
                          name: "import-resolution-manual",
                          size: "small",
                          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
                        }
                      ),
                      /* @__PURE__ */ r.jsx(ye, { variant: "caption", children: "Overwrite existing concept-sets" }),
                      /* @__PURE__ */ r.jsx(mt, { text: "Fully identical concept set(s) will not be created, instead existing ones will be reused. Concept set(s) with the same name, but different content will create a new version of the existing ones and Cohort design will reference these newly created versions.", children: /* @__PURE__ */ r.jsx(
                        oe,
                        {
                          iconName: "info",
                          sx: { fontSize: 12, color: "text.secondary" }
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ r.jsxs(ge, { display: "flex", alignItems: "center", columnGap: 0.75, children: [
                      /* @__PURE__ */ r.jsx(
                        At,
                        {
                          checked: i === te.CREATE_NEW_OBJECT,
                          onChange: () => y(
                            te.CREATE_NEW_OBJECT
                          ),
                          name: "import-resolution-manual",
                          size: "small",
                          sx: { p: 0.25, "& .MuiSvgIcon-root": { fontSize: 16 } }
                        }
                      ),
                      /* @__PURE__ */ r.jsx(ye, { variant: "caption", children: "Create new concept-sets" }),
                      /* @__PURE__ */ r.jsx(mt, { text: "New concept set(s) will be created, even if identical concept set(s) exist.", children: /* @__PURE__ */ r.jsx(
                        oe,
                        {
                          iconName: "info",
                          sx: { fontSize: 12, color: "text.secondary" }
                        }
                      ) })
                    ] })
                  ]
                }
              )
            ]
          }
        ) : null
      }
    ) }) });
  }
);
Ce.div`
  padding: 8px 16px;
  .concept-set-list {
    > .content-block {
      border: none;
      box-shadow: none;
      > div {
        padding: 10px 0;
      }
    }
  }
`;
const ha = Ce.div`
  padding: 0px 16px 16px;
`;
Ce.div`
  margin-top: 10px;
  .concept-set-table {
    visibility: hidden;
    max-height: 0;
    overflow-y: hidden;
    &.selected {
      visibility: visible;
      max-height: 600px;
      padding: 8px;
    }
  }

  :hover {
    .concept-set-table {
      visibility: visible;
      max-height: 600px;
      padding: 8px;
    }
  }
`;
Ce.div`
  padding: 10px 20px 0;
  border-bottom: 3px solid #d8e1ef;
  .item:not(.active-item) {
    background-color: #ffffff;
  }
`;
Ce.div`
  padding: 10px 0;
`;
Ce.div`
  padding: 10px;
  display: flex;
`;
const Ea = Ce.div`
  &:hover {
    text-decoration: underline;
  }
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  white-space: pre-wrap;
  .MuiCheckbox-root {
    padding: 2px;
    margin-right: 8px;
  }
  .MuiSvgIcon-root {
    font-size: 16px;
  }
`, ga = Ce.div`
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.grey[400];
}};
  padding: 12px;
  text-align: center;
`, Sa = Ce(Wt)`
  font-size: 12px;
  margin-bottom: 8px;
  .collapsible-block__content-container {
    padding: 0;
    border-bottom-right-radius: 4px;
  }
  .collapsible-content-block__title {
    padding: 0 12px;
    line-height: 36px;
    & > .MuiSvgIcon-root {
      display: none;
    }
  }
`, xa = [
  {
    Header: "Id",
    accessor: "concept.CONCEPT_ID"
  },
  {
    Header: "Code",
    accessor: "concept.CONCEPT_CODE",
    maxWidth: 150,
    isCropped: !0
  },
  {
    Header: "Name",
    accessor: "concept.CONCEPT_NAME",
    maxWidth: 400,
    isCropped: !0
  },
  {
    Header: "Class",
    accessor: "concept.CONCEPT_CLASS_ID",
    maxWidth: 150,
    isCropped: !0
  },
  {
    Header: "Domain",
    accessor: "concept.DOMAIN_ID"
  },
  {
    Header: "Vocabulary",
    accessor: "concept.VOCABULARY_ID",
    maxWidth: 150,
    isCropped: !0
  },
  {
    Header: "Exclude",
    accessor: "excluded",
    align: "left",
    Cell: (e) => /* @__PURE__ */ r.jsx(It, { ...e, align: "left", disabled: !0 }),
    disableSortBy: !0
  },
  {
    Header: "Descendants",
    accessor: "descendants",
    align: "left",
    Cell: (e) => /* @__PURE__ */ r.jsx(It, { ...e, align: "left", disabled: !0 }),
    disableSortBy: !0
  },
  {
    Header: "Mapped",
    accessor: "mapped",
    align: "left",
    Cell: (e) => /* @__PURE__ */ r.jsx(It, { ...e, align: "left", disabled: !0 }),
    disableSortBy: !0
  },
  {
    Header: "Hierarchy",
    accessor: "hierarchy",
    align: "left",
    Cell: (e) => /* @__PURE__ */ r.jsx(It, { ...e, align: "left", disabled: !0 }),
    disableSortBy: !0
  }
], Wr = Me((e) => {
  const { conceptSets: t, currentConceptSet: n, onChange: s, viewMode: a } = e;
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: t != null && t.length ? (t || []).filter(
    (o) => a ? (n == null ? void 0 : n.id) == o.id : o
  ).map((o) => {
    var i, l;
    return /* @__PURE__ */ r.jsx(
      Sa,
      {
        collapsible: !a,
        defaultState: (n == null ? void 0 : n.id) == o.id,
        title: /* @__PURE__ */ r.jsxs(Ea, { children: [
          /* @__PURE__ */ r.jsx(
            fr,
            {
              disabled: a,
              checked: (n == null ? void 0 : n.id) == o.id,
              onClick: (p) => {
                s(o, !1);
              },
              sx: { mr: 2 }
            }
          ),
          o.name
        ] }),
        children: /* @__PURE__ */ r.jsx(
          ha,
          {
            className: "concept-set-table" + ((n == null ? void 0 : n.id) == o.id ? " selected" : ""),
            children: (i = o == null ? void 0 : o.expression) != null && i.items && Object.values((l = o == null ? void 0 : o.expression) == null ? void 0 : l.items).length ? /* @__PURE__ */ r.jsx(
              mr,
              {
                columns: xa,
                data: Object.values(o.expression.items),
                onEdit: () => {
                }
              }
            ) : /* @__PURE__ */ r.jsx(ga, { children: "Empty concept set" })
          }
        )
      },
      o.id
    );
  }) : /* @__PURE__ */ r.jsx(Cn, { children: /* @__PURE__ */ r.jsx(_s, { noDataText: "No concept sets found, please import or create a concept set" }) }) });
}), Ut = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return String(e);
  if (typeof e != "string")
    return;
  const t = e.trim();
  return t.length > 0 ? t : void 0;
}, ar = (e, t = !1) => {
  var i;
  const n = e.data || e, s = Ut(n.uuid) || Ut(n.id), a = n.externalId ?? n.id, o = n.items || ((i = n.expression) == null ? void 0 : i.items) || {};
  return {
    id: t && a !== void 0 ? a : Qs(),
    name: n.name || "New Concept set",
    expression: {
      items: wt(o)
    },
    versionId: n.versionId,
    currentVersionId: n.currentVersionId || n.versionId,
    version: n.version,
    versionOrdinal: n.versionOrdinal || n.version,
    currentVersionOrdinal: n.currentVersionOrdinal || n.versionOrdinal || n.version,
    ...s ? {
      isNewImport: !0,
      uuid: s,
      referenceId: s,
      externalId: a
    } : {}
  };
}, Vr = Me((e) => {
  const {
    simpleButtonMode: t = !1,
    localImport: n = !1,
    embeddedReferenceOnly: s = !1,
    defaultValue: a,
    conceptSetId: o,
    conceptSets: i,
    onUpdate: l,
    onClear: p,
    typeContainer: c,
    parentId: d,
    subModules: f,
    dense: E = !0,
    circleMode: h,
    importMultiSelect: x = !1,
    ...D
  } = e, { openModal: L, closeModal: N } = Ie(He), [M, $] = Z(
    tn(o, i || [])
  );
  J(() => {
    t || $(tn(o, i || []));
  }, [o, i, t]);
  const y = B(() => In(c, d), [c, d]), g = B(() => {
    const K = /* @__PURE__ */ new Set();
    return i.forEach((S) => {
      const R = S;
      [
        R == null ? void 0 : R.uuid,
        R == null ? void 0 : R.id,
        R == null ? void 0 : R.externalId
      ].map(Ut).forEach((q) => {
        q && K.add(q);
      });
    }), K;
  }, [i]), v = s || c === b.LIBRARY, A = n && (!v || i.length > 0), U = B(
    () => (K) => {
      const S = (K == null ? void 0 : K.original) || {};
      return [
        S == null ? void 0 : S.id,
        S == null ? void 0 : S.uuid,
        S == null ? void 0 : S.externalId
      ].map(Ut).some(
        (q) => !!(q && g.has(q))
      );
    },
    [g]
  ), Y = () => {
    L(
      () => {
        var K;
        return /* @__PURE__ */ r.jsx(
          Sn,
          {
            name: "concept-sets",
            currentContainer: c,
            parentId: d,
            onChange: async (S) => {
              const R = (Array.isArray(S) ? S : []).filter(Boolean).map(
                (q) => ar(q, v)
              );
              if (R.length === 0) {
                N();
                return;
              }
              t || $(R[0]), x ? R.forEach(
                (q) => l(q, !0)
              ) : l(R[0], !0), N();
            },
            getEntity: Ft,
            createListMethods: Lt,
            cols: Gt,
            createListFiltersMethod: Mt,
            createMethodCreate: st,
            subModules: f,
            analysisMode: !0,
            isSelect: x,
            hideConflictResolutionControls: !0,
            hidePendingCancelButton: !x,
            toggleSingleSelectionOnRowClick: !x,
            disableRowSelect: U,
            disableRowSelectOnSameContainerOnly: !0,
            atlasEntity: [ht.CS],
            successMessage: "Concept set(s) successfully imported.",
            manualImport: !v,
            disableImportContainer: v,
            disableAltasImport: v,
            disableCopy: v,
            manualImportComponent: /* @__PURE__ */ r.jsx(
              vn,
              {
                typeContainer: c,
                createMethod: y,
                parentId: d,
                onClose: N,
                onChange: (S) => {
                  const R = ar(
                    S,
                    v
                  );
                  t || $(R), l(R, !0), N();
                }
              }
            ),
            localImport: A,
            localImportComponent: /* @__PURE__ */ r.jsx(
              Wr,
              {
                onChange: (S, R) => {
                  t || $({
                    ...S,
                    expression: {
                      items: wt(
                        S.expression.items || {}
                      )
                    }
                  }), l(
                    {
                      ...S,
                      expression: {
                        items: wt(
                          S.expression.items || {}
                        )
                      }
                    },
                    R
                  ), N();
                },
                currentConceptSet: {
                  ...M,
                  expression: {
                    items: ft(
                      ((K = M == null ? void 0 : M.expression) == null ? void 0 : K.items) || []
                    )
                  }
                },
                conceptSets: i.map((S) => {
                  var R;
                  return {
                    ...S,
                    expression: {
                      items: ft(
                        ((R = S == null ? void 0 : S.expression) == null ? void 0 : R.items) || []
                      )
                    }
                  };
                })
              }
            )
          }
        );
      },
      "Import concept set",
      {
        onClose: N,
        closeOnClickOutside: !0
      }
    );
  }, ie = () => {
    $(null), p();
  };
  return /* @__PURE__ */ r.jsxs(Os, { children: [
    /* @__PURE__ */ r.jsx(
      oa,
      {
        title: M && !t ? Ks(M.name, 35) : a,
        onClick: Y
      }
    ),
    M && /* @__PURE__ */ r.jsx(
      de,
      {
        size: "medium",
        variant: "outlined",
        className: "button-component-icon",
        onClick: ie,
        name: "clearCriteriaConceptSet",
        startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "close", name: "delete" }),
        sx: {
          px: 0.5,
          "&.MuiButtonGroup-grouped": {
            minWidth: 32
          },
          ".start-icon": {
            margin: 0
          }
        }
      }
    )
  ] });
}), ya = {
  createCols: (e, t = {}, n = !1, s = []) => [
    {
      Header: "Name",
      accessor: "name",
      id: "name",
      isCropped: !0,
      width: "100%",
      minWidth: 250,
      maxWidth: 400,
      Cell: (a) => /* @__PURE__ */ r.jsx(
        ho,
        {
          ...a,
          hasAlias: n,
          onChange: t.onUpdate,
          aliases: s,
          entityType: je.CONCEPT_SET
        }
      )
    },
    ...e ? [] : [
      {
        Header: "",
        accessor: "actions",
        isCropped: !0,
        maxWidth: 100,
        width: "7%",
        disableSortBy: !0,
        Cell: (a) => /* @__PURE__ */ r.jsx(
          Eo,
          {
            onRemove: () => t.onRemove(a.row.original.id)
          }
        )
      }
    ]
  ]
}, Ta = (e) => {
  var v, A, U;
  const {
    titleText: t,
    description: n,
    buttonText: s,
    typeContainer: a,
    parentId: o,
    onChange: i,
    initialData: l,
    isSelect: p,
    subModules: c,
    viewMode: d,
    withAlias: f = !1
  } = e, { createCols: E } = ya, { openModal: h, closeModal: x } = Ie(He), D = B(() => In(a, o), [a, o]), { state: L, updateList: N, removeItem: M, updateItem: $ } = ws(
    l,
    p,
    i,
    f
  ), y = E(
    d,
    {
      onRemove: M,
      onUpdate: $
    },
    f,
    Object.values(L).map((Y) => Y.alias || null)
  ), g = () => {
    h(
      () => /* @__PURE__ */ r.jsx(
        Sn,
        {
          name: "concept-sets",
          currentContainer: a,
          parentId: o,
          defaultResolution: te.CREATE_NEW_OBJECT,
          hideConflictResolutionMethod: !0,
          hideConflictResolutionControls: !0,
          onChange: (Y) => {
            Y.forEach((ie) => {
              Ft(ie.id).then((K) => {
                N(K, x);
              });
            });
          },
          createListMethods: Lt,
          cols: Gt,
          createListFiltersMethod: Mt,
          createMethodCreate: st,
          subModules: c,
          isSelect: p,
          atlasEntity: [ht.CS],
          analysisMode: !0,
          successMessage: "Concept set(s) successfully imported.",
          manualImport: !0,
          manualImportComponent: /* @__PURE__ */ r.jsx(
            vn,
            {
              createMethod: D,
              typeContainer: a,
              parentId: o,
              onClose: x,
              onChange: (Y) => {
                N([Y], x);
              }
            }
          )
        }
      ),
      "Import concept set",
      {
        onClose: x,
        closeOnClickOutside: !0
      }
    );
  };
  return /* @__PURE__ */ r.jsx(
    Wt,
    {
      elevated: !0,
      outlined: !0,
      title: t,
      actions: d ? void 0 : /* @__PURE__ */ r.jsx(T, { item: !0, children: /* @__PURE__ */ r.jsx(
        de,
        {
          onClick: g,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "add", fontSize: "small" }),
          name: "importConceptSet",
          sx: { px: 3 },
          children: s
        }
      ) }),
      children: /* @__PURE__ */ r.jsxs(T, { container: !0, children: [
        /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
          T,
          {
            container: !0,
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "nowrap",
            mb: 1,
            children: /* @__PURE__ */ r.jsx(ye, { variant: "subtitle2", component: "div", children: n || "" })
          }
        ) }),
        ((v = Object.values(L)) == null ? void 0 : v.length) > 0 ? /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, className: "table-cohorts", children: /* @__PURE__ */ r.jsx(
          mr,
          {
            columns: y,
            data: Object.values(L),
            loadingMessage: "",
            totalElements: (A = Object.values(L)) == null ? void 0 : A.length,
            pageSize: (U = Object.values(L)) == null ? void 0 : U.length,
            enableSorting: p,
            tileView: !0
          }
        ) }) : /* @__PURE__ */ r.jsx(
          T,
          {
            item: !0,
            xs: 12,
            sx: {
              backgroundColor: "backgroundColor.main",
              textAlign: "center",
              p: 1
            },
            children: /* @__PURE__ */ r.jsx(ye, { variant: "subtitle2", color: "borderColor.main", children: "No concept sets" })
          }
        )
      ] })
    }
  );
}, Ia = (e, t) => {
  var s, a;
  const n = (a = (s = e == null ? void 0 : e.response) == null ? void 0 : s.data) == null ? void 0 : a.message;
  return n || t;
}, va = (e) => typeof e == "boolean" ? e : !e || typeof e != "object" ? !0 : typeof e.available == "boolean" ? e.available : typeof e.isAvailable == "boolean" ? e.isAvailable : typeof e.success == "boolean" ? e.success : typeof e.result == "boolean" ? e.result : typeof e.unique == "boolean" ? e.unique : typeof e.isUnique == "boolean" ? e.isUnique : typeof e.valid == "boolean" ? e.valid : typeof e.isValid == "boolean" ? e.isValid : typeof e.exists == "boolean" ? !e.exists : typeof e.duplicate == "boolean" ? !e.duplicate : typeof e.conflict == "boolean" ? !e.conflict : typeof e.used == "boolean" ? !e.used : !0, ze = async (e, t, n, s) => {
  const a = t == null ? void 0 : t.trim();
  if (!a)
    return {
      isValid: !1,
      message: "Name is required."
    };
  try {
    const o = await $r(
      e,
      a,
      n,
      s
    ), i = va(o);
    return {
      isValid: i,
      message: i ? void 0 : (o == null ? void 0 : o.message) || "Error! Name is already used by another object."
    };
  } catch (o) {
    return {
      isValid: !1,
      message: Ia(
        o,
        "Unable to validate name uniqueness. Please try again."
      )
    };
  }
}, _n = Me(
  (e) => {
    const { parentId: t, typeContainer: n, afterCreate: s, onCancel: a, createMethod: o } = e, [i, l] = Z(!1), [p, c] = Z(""), [d, f] = Z({
      name: "",
      description: "",
      studyId: t
    }), E = F(async () => {
      l(!0);
      const h = await ze(
        n,
        d.name,
        t
      );
      if (!h.isValid) {
        l(!1), c(h.message || "");
        return;
      }
      c(""), o(d).then((x) => {
        l(!1), s == null || s(x);
      });
    }, [t, d, o, n]);
    return /* @__PURE__ */ r.jsx(T, { container: !0, p: 2, children: /* @__PURE__ */ r.jsx(Cn, { elevated: !0, outlined: !0, children: /* @__PURE__ */ r.jsxs(T, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(we, { name: "name", textLabel: "Name", required: !0, children: [
        /* @__PURE__ */ r.jsx(
          Le,
          {
            id: "name",
            name: "name",
            type: "text",
            size: "medium",
            value: d.name,
            placeholder: "Enter name",
            onChange: (h) => {
              c(""), f({ ...d, name: h.target.value });
            },
            fullWidth: !0
          }
        ),
        p && /* @__PURE__ */ r.jsx(ye, { color: "error.main", variant: "caption", children: p })
      ] }) }),
      /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(we, { name: "description", textLabel: "Description", children: /* @__PURE__ */ r.jsx(
        Le,
        {
          id: "description",
          name: "description",
          type: "text",
          size: "medium",
          value: d.description,
          placeholder: "Enter description",
          onChange: (h) => f({ ...d, description: h.target.value }),
          fullWidth: !0,
          multiline: !0,
          minRows: 2,
          maxRows: 10
        }
      ) }) }),
      /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(Er, { children: [
        /* @__PURE__ */ r.jsx(
          de,
          {
            variant: "outlined",
            disabled: i,
            onClick: a,
            startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "deactivate" }),
            name: "cancel",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ r.jsx(
          de,
          {
            disabled: i || bt(d.name),
            onClick: E,
            variant: "contained",
            color: "success",
            startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "submit" }),
            name: "save",
            children: "Save"
          }
        )
      ] }) })
    ] }) }) });
  }
), _a = () => {
  const e = Vt(), { openModal: t, closeModal: n } = mn.useContext(He), { enqueueSnackbar: s } = ot(), a = (o) => {
    o.stopPropagation(), t(
      () => /* @__PURE__ */ r.jsx(
        _n,
        {
          typeContainer: b.WORKSPACE,
          createMethod: zt,
          onCancel: n,
          afterCreate: (i) => {
            s({
              message: "Concept set created successfully",
              variant: "success"
            }), e(`/workspace/concept-sets/${i.id}`), n();
          }
        }
      ),
      "Add concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: n
      }
    );
  };
  return /* @__PURE__ */ r.jsx(
    go,
    {
      title: "Concept sets",
      description: "Concept sets include a group of OMOP medical concepts. Construct a new concept set to describe a phenotype to be shared across different cohorts, analyses and even studies.",
      iconName: "conceptSets",
      onCardClick: () => e("/workspace/concept-sets"),
      children: /* @__PURE__ */ r.jsx(T, { item: !0, width: 90, textAlign: "right", children: /* @__PURE__ */ r.jsx(
        de,
        {
          onClick: a,
          variant: "contained",
          color: "info",
          startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "add" }),
          name: "save",
          children: "Create"
        }
      ) })
    }
  );
}, Fr = (e, t, n, s) => (a, o, i = te.COPY) => {
  switch (e) {
    case b.STUDY:
      return Pr(t, a, o, i);
    case b.WORKSPACE:
      return wr(a, o, i);
    case "ATLAS":
      return Qo(n, s, a, o);
  }
}, Oa = (e, t) => (n = 0, s = 1e6, a, o) => {
  switch (e) {
    case b.STUDY:
      return Rr(t, {
        pageNumber: n,
        pageSize: s,
        sortBy: a,
        query: o
      });
    case b.WORKSPACE:
      return Nr({
        pageNumber: n,
        pageSize: s,
        sortBy: a,
        query: o
      });
    case b.LIBRARY:
      return br({
        pageNumber: n,
        pageSize: s,
        sortBy: a,
        query: o
      });
    default:
      return Or({
        pageNumber: n,
        pageSize: s,
        sortBy: a,
        query: o
      });
  }
}, Na = (e, t) => {
  switch (e) {
    case b.WORKSPACE:
      return (n) => zt(n);
    case b.STUDY:
      return (n) => Tn(t, n);
  }
}, ba = (e) => e.map((t) => ({
  value: t.id,
  name: t.name
}));
function ir(e) {
  const t = {};
  for (const n of Object.values(e))
    t[n.id] = n;
  return t;
}
function Ge(e) {
  var n;
  const t = {};
  for (const [s, a] of Object.entries(e)) {
    const o = (a == null ? void 0 : a.conceptId) ?? ((n = a == null ? void 0 : a.concept) == null ? void 0 : n.CONCEPT_ID);
    if (!Number.isFinite(Number(o)))
      continue;
    const { excluded: i, mapped: l, descendants: p, hierarchy: c } = a || {};
    t[s] = {
      conceptId: Number(o),
      excluded: !!i,
      mapped: !!l,
      descendants: !!p,
      hierarchy: !!c
    };
  }
  return t;
}
function Ra(e, t) {
  return e.filter((n) => t.includes(n.op));
}
function Aa(e) {
  return Object.fromEntries(
    Object.entries(e).map(([t, n]) => [t, { ...n, id: t }])
  );
}
const ja = ["excluded", "mapped", "descendants", "hierarchy"];
function zr(e, t) {
  const n = {}, s = /* @__PURE__ */ new Set(), a = [];
  for (const o of e) {
    const i = o.path.match(/^\/items\/([^/]+)\/([^/]+)$/);
    if (o.op === "replace" && i && ja.includes(i[2])) {
      const [l, p, c] = i;
      n[p] || (n[p] = {}), n[p][c] = o.value, s.add(p);
    } else {
      const l = o.path.replace(/^\/items\//, "/");
      a.push({
        ...o,
        path: l
      });
    }
  }
  for (const o of s) {
    const i = t[o];
    if (i) {
      const l = { ...i, ...n[o] };
      a.push({
        op: "replace",
        path: `/${o}`,
        value: l
      });
    }
  }
  return a;
}
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */
var wa = /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(s, a) {
      s.__proto__ = a;
    } || function(s, a) {
      for (var o in a) a.hasOwnProperty(o) && (s[o] = a[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function s() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  };
}(), Pa = Object.prototype.hasOwnProperty;
function cn(e, t) {
  return Pa.call(e, t);
}
function ln(e) {
  if (Array.isArray(e)) {
    for (var t = new Array(e.length), n = 0; n < t.length; n++)
      t[n] = "" + n;
    return t;
  }
  if (Object.keys)
    return Object.keys(e);
  var s = [];
  for (var a in e)
    cn(e, a) && s.push(a);
  return s;
}
function Se(e) {
  switch (typeof e) {
    case "object":
      return JSON.parse(JSON.stringify(e));
    case "undefined":
      return null;
    default:
      return e;
  }
}
function dn(e) {
  for (var t = 0, n = e.length, s; t < n; ) {
    if (s = e.charCodeAt(t), s >= 48 && s <= 57) {
      t++;
      continue;
    }
    return !1;
  }
  return !0;
}
function We(e) {
  return e.indexOf("/") === -1 && e.indexOf("~") === -1 ? e : e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Gr(e) {
  return e.replace(/~1/g, "/").replace(/~0/g, "~");
}
function un(e) {
  if (e === void 0)
    return !0;
  if (e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = e.length; t < n; t++)
        if (un(e[t]))
          return !0;
    } else if (typeof e == "object") {
      for (var s = ln(e), a = s.length, o = 0; o < a; o++)
        if (un(e[s[o]]))
          return !0;
    }
  }
  return !1;
}
function cr(e, t) {
  var n = [e];
  for (var s in t) {
    var a = typeof t[s] == "object" ? JSON.stringify(t[s], null, 2) : t[s];
    typeof a < "u" && n.push(s + ": " + a);
  }
  return n.join(`
`);
}
var Yr = (
  /** @class */
  function(e) {
    wa(t, e);
    function t(n, s, a, o, i) {
      var l = this.constructor, p = e.call(this, cr(n, { name: s, index: a, operation: o, tree: i })) || this;
      return p.name = s, p.index = a, p.operation = o, p.tree = i, Object.setPrototypeOf(p, l.prototype), p.message = cr(n, { name: s, index: a, operation: o, tree: i }), p;
    }
    return t;
  }(Error)
), se = Yr, Da = Se, tt = {
  add: function(e, t, n) {
    return e[t] = this.value, { newDocument: n };
  },
  remove: function(e, t, n) {
    var s = e[t];
    return delete e[t], { newDocument: n, removed: s };
  },
  replace: function(e, t, n) {
    var s = e[t];
    return e[t] = this.value, { newDocument: n, removed: s };
  },
  move: function(e, t, n) {
    var s = kt(n, this.path);
    s && (s = Se(s));
    var a = Ye(n, { op: "remove", path: this.from }).removed;
    return Ye(n, { op: "add", path: this.path, value: a }), { newDocument: n, removed: s };
  },
  copy: function(e, t, n) {
    var s = kt(n, this.from);
    return Ye(n, { op: "add", path: this.path, value: Se(s) }), { newDocument: n };
  },
  test: function(e, t, n) {
    return { newDocument: n, test: Ct(e[t], this.value) };
  },
  _get: function(e, t, n) {
    return this.value = e[t], { newDocument: n };
  }
}, La = {
  add: function(e, t, n) {
    return dn(t) ? e.splice(t, 0, this.value) : e[t] = this.value, { newDocument: n, index: t };
  },
  remove: function(e, t, n) {
    var s = e.splice(t, 1);
    return { newDocument: n, removed: s[0] };
  },
  replace: function(e, t, n) {
    var s = e[t];
    return e[t] = this.value, { newDocument: n, removed: s };
  },
  move: tt.move,
  copy: tt.copy,
  test: tt.test,
  _get: tt._get
};
function kt(e, t) {
  if (t == "")
    return e;
  var n = { op: "_get", path: t };
  return Ye(e, n), n.value;
}
function Ye(e, t, n, s, a, o) {
  if (n === void 0 && (n = !1), s === void 0 && (s = !0), a === void 0 && (a = !0), o === void 0 && (o = 0), n && (typeof n == "function" ? n(t, 0, e, t.path) : $t(t, 0)), t.path === "") {
    var i = { newDocument: e };
    if (t.op === "add")
      return i.newDocument = t.value, i;
    if (t.op === "replace")
      return i.newDocument = t.value, i.removed = e, i;
    if (t.op === "move" || t.op === "copy")
      return i.newDocument = kt(e, t.from), t.op === "move" && (i.removed = e), i;
    if (t.op === "test") {
      if (i.test = Ct(e, t.value), i.test === !1)
        throw new se("Test operation failed", "TEST_OPERATION_FAILED", o, t, e);
      return i.newDocument = e, i;
    } else {
      if (t.op === "remove")
        return i.removed = e, i.newDocument = null, i;
      if (t.op === "_get")
        return t.value = e, i;
      if (n)
        throw new se("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", o, t, e);
      return i;
    }
  } else {
    s || (e = Se(e));
    var l = t.path || "", p = l.split("/"), c = e, d = 1, f = p.length, E = void 0, h = void 0, x = void 0;
    for (typeof n == "function" ? x = n : x = $t; ; ) {
      if (h = p[d], h && h.indexOf("~") != -1 && (h = Gr(h)), a && (h == "__proto__" || h == "prototype" && d > 0 && p[d - 1] == "constructor"))
        throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
      if (n && E === void 0 && (c[h] === void 0 ? E = p.slice(0, d).join("/") : d == f - 1 && (E = t.path), E !== void 0 && x(t, 0, e, E)), d++, Array.isArray(c)) {
        if (h === "-")
          h = c.length;
        else {
          if (n && !dn(h))
            throw new se("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", o, t, e);
          dn(h) && (h = ~~h);
        }
        if (d >= f) {
          if (n && t.op === "add" && h > c.length)
            throw new se("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", o, t, e);
          var i = La[t.op].call(t, c, h, e);
          if (i.test === !1)
            throw new se("Test operation failed", "TEST_OPERATION_FAILED", o, t, e);
          return i;
        }
      } else if (d >= f) {
        var i = tt[t.op].call(t, c, h, e);
        if (i.test === !1)
          throw new se("Test operation failed", "TEST_OPERATION_FAILED", o, t, e);
        return i;
      }
      if (c = c[h], n && d < f && (!c || typeof c != "object"))
        throw new se("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", o, t, e);
    }
  }
}
function On(e, t, n, s, a) {
  if (s === void 0 && (s = !0), a === void 0 && (a = !0), n && !Array.isArray(t))
    throw new se("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
  s || (e = Se(e));
  for (var o = new Array(t.length), i = 0, l = t.length; i < l; i++)
    o[i] = Ye(e, t[i], n, !0, a, i), e = o[i].newDocument;
  return o.newDocument = e, o;
}
function Ma(e, t, n) {
  var s = Ye(e, t);
  if (s.test === !1)
    throw new se("Test operation failed", "TEST_OPERATION_FAILED", n, t, e);
  return s.newDocument;
}
function $t(e, t, n, s) {
  if (typeof e != "object" || e === null || Array.isArray(e))
    throw new se("Operation is not an object", "OPERATION_NOT_AN_OBJECT", t, e, n);
  if (tt[e.op]) {
    if (typeof e.path != "string")
      throw new se("Operation `path` property is not a string", "OPERATION_PATH_INVALID", t, e, n);
    if (e.path.indexOf("/") !== 0 && e.path.length > 0)
      throw new se('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", t, e, n);
    if ((e.op === "move" || e.op === "copy") && typeof e.from != "string")
      throw new se("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", t, e, n);
    if ((e.op === "add" || e.op === "replace" || e.op === "test") && e.value === void 0)
      throw new se("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", t, e, n);
    if ((e.op === "add" || e.op === "replace" || e.op === "test") && un(e.value))
      throw new se("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", t, e, n);
    if (n) {
      if (e.op == "add") {
        var a = e.path.split("/").length, o = s.split("/").length;
        if (a !== o + 1 && a !== o)
          throw new se("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", t, e, n);
      } else if (e.op === "replace" || e.op === "remove" || e.op === "_get") {
        if (e.path !== s)
          throw new se("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", t, e, n);
      } else if (e.op === "move" || e.op === "copy") {
        var i = { op: "_get", path: e.from, value: void 0 }, l = Hr([i], n);
        if (l && l.name === "OPERATION_PATH_UNRESOLVABLE")
          throw new se("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", t, e, n);
      }
    }
  } else throw new se("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", t, e, n);
}
function Hr(e, t, n) {
  try {
    if (!Array.isArray(e))
      throw new se("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    if (t)
      On(Se(t), Se(e), n || !0);
    else {
      n = n || $t;
      for (var s = 0; s < e.length; s++)
        n(e[s], s, t, void 0);
    }
  } catch (a) {
    if (a instanceof se)
      return a;
    throw a;
  }
}
function Ct(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    var n = Array.isArray(e), s = Array.isArray(t), a, o, i;
    if (n && s) {
      if (o = e.length, o != t.length)
        return !1;
      for (a = o; a-- !== 0; )
        if (!Ct(e[a], t[a]))
          return !1;
      return !0;
    }
    if (n != s)
      return !1;
    var l = Object.keys(e);
    if (o = l.length, o !== Object.keys(t).length)
      return !1;
    for (a = o; a-- !== 0; )
      if (!t.hasOwnProperty(l[a]))
        return !1;
    for (a = o; a-- !== 0; )
      if (i = l[a], !Ct(e[i], t[i]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
const Ua = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  JsonPatchError: se,
  _areEquals: Ct,
  applyOperation: Ye,
  applyPatch: On,
  applyReducer: Ma,
  deepClone: Da,
  getValueByPointer: kt,
  validate: Hr,
  validator: $t
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2021 Joachim Wester
 * MIT license
 */
var Nn = /* @__PURE__ */ new WeakMap(), ka = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.observers = /* @__PURE__ */ new Map(), this.obj = t;
    }
    return e;
  }()
), $a = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      this.callback = t, this.observer = n;
    }
    return e;
  }()
);
function Ba(e) {
  return Nn.get(e);
}
function Wa(e, t) {
  return e.observers.get(t);
}
function Va(e, t) {
  e.observers.delete(t.callback);
}
function Fa(e, t) {
  t.unobserve();
}
function za(e, t) {
  var n = [], s, a = Ba(e);
  if (!a)
    a = new ka(e), Nn.set(e, a);
  else {
    var o = Wa(a, t);
    s = o && o.observer;
  }
  if (s)
    return s;
  if (s = {}, a.value = Se(e), t) {
    s.callback = t, s.next = null;
    var i = function() {
      pn(s);
    }, l = function() {
      clearTimeout(s.next), s.next = setTimeout(i);
    };
    typeof window < "u" && (window.addEventListener("mouseup", l), window.addEventListener("keyup", l), window.addEventListener("mousedown", l), window.addEventListener("keydown", l), window.addEventListener("change", l));
  }
  return s.patches = n, s.object = e, s.unobserve = function() {
    pn(s), clearTimeout(s.next), Va(a, s), typeof window < "u" && (window.removeEventListener("mouseup", l), window.removeEventListener("keyup", l), window.removeEventListener("mousedown", l), window.removeEventListener("keydown", l), window.removeEventListener("change", l));
  }, a.observers.set(t, new $a(t, s)), s;
}
function pn(e, t) {
  t === void 0 && (t = !1);
  var n = Nn.get(e.object);
  bn(n.value, e.object, e.patches, "", t), e.patches.length && On(n.value, e.patches);
  var s = e.patches;
  return s.length > 0 && (e.patches = [], e.callback && e.callback(s)), s;
}
function bn(e, t, n, s, a) {
  if (t !== e) {
    typeof t.toJSON == "function" && (t = t.toJSON());
    for (var o = ln(t), i = ln(e), l = !1, p = i.length - 1; p >= 0; p--) {
      var c = i[p], d = e[c];
      if (cn(t, c) && !(t[c] === void 0 && d !== void 0 && Array.isArray(t) === !1)) {
        var f = t[c];
        typeof d == "object" && d != null && typeof f == "object" && f != null && Array.isArray(d) === Array.isArray(f) ? bn(d, f, n, s + "/" + We(c), a) : d !== f && (a && n.push({ op: "test", path: s + "/" + We(c), value: Se(d) }), n.push({ op: "replace", path: s + "/" + We(c), value: Se(f) }));
      } else Array.isArray(e) === Array.isArray(t) ? (a && n.push({ op: "test", path: s + "/" + We(c), value: Se(d) }), n.push({ op: "remove", path: s + "/" + We(c) }), l = !0) : (a && n.push({ op: "test", path: s, value: e }), n.push({ op: "replace", path: s, value: t }));
    }
    if (!(!l && o.length == i.length))
      for (var p = 0; p < o.length; p++) {
        var c = o[p];
        !cn(e, c) && t[c] !== void 0 && n.push({ op: "add", path: s + "/" + We(c), value: Se(t[c]) });
      }
  }
}
function Yt(e, t, n) {
  n === void 0 && (n = !1);
  var s = [];
  return bn(e, t, s, "", n), s;
}
const Ga = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compare: Yt,
  generate: pn,
  observe: za,
  unobserve: Fa
}, Symbol.toStringTag, { value: "Module" }));
Object.assign({}, Ua, Ga, {
  JsonPatchError: Yr,
  deepClone: Se,
  escapePathComponent: We,
  unescapePathComponent: Gr
});
var Fe = /* @__PURE__ */ ((e) => (e.LOADED_LIST = "LOADED_LIST", e.FAILED_LOADED_LIST = "FAILED_LOADED_LIST", e.IN_PROGRESS_CREATION = "IN_PROGRESS_CREATION", e.CREATED_SUCCESS = "CREATED_SUCCESS", e.UPDATED_SUCCESS = "UPDATED_SUCCESS", e))(Fe || {});
const Ya = {
  conceptSets: [],
  status: P.INITIAL,
  typeContainer: b.WORKSPACE,
  conceptSet: null,
  parentId: null,
  error: null
}, Ha = (e, t) => gn(
  e,
  (n) => {
    switch (t.type) {
      case "INITIAL_PARAMS":
        n.typeContainer = t.payload.typeContainer, n.parentId = t.payload.parentId;
        break;
      case "GET_CONCEPT_SETS":
        n.conceptSets = [], n.status = P.IN_PROGRESS;
        break;
      case "GET_CONCEPT_SETS_DONE":
        n.conceptSets = t.payload, n.status = "LOADED_LIST";
        break;
      case "GET_CONCEPT_SETS_FAILED":
        n.status = "FAILED_LOADED_LIST";
        break;
      case "CREATE_CONCEPT_SET":
      case "UPDATE_CONCEPT_SET":
        n.status = "IN_PROGRESS_CREATION";
        break;
      case "CREATE_CONCEPT_SET_DONE":
        n.conceptSet = t.payload, n.status = "CREATED_SUCCESS";
        break;
      case "UPDATE_CONCEPT_SET_DONE":
        n.conceptSet = t.payload, n.status = "UPDATED_SUCCESS";
        break;
    }
  }
), qa = (e, t) => {
  const [n, s] = fn(Ha, Ya), a = (c, d) => {
    s({
      type: "INITIAL_PARAMS",
      payload: {
        typeContainer: c,
        parentId: d
      }
    });
  }, o = F(async () => {
    s({
      type: "GET_CONCEPT_SETS"
      /* GET_CONCEPT_SETS */
    });
    const c = Oa(n.typeContainer, n.parentId);
    try {
      const d = await c();
      s({
        type: "GET_CONCEPT_SETS_DONE",
        payload: ba(d.content)
      });
    } catch (d) {
      console.log("error", d), s({
        type: "GET_CONCEPT_SETS_FAILED"
        /* GET_CONCEPT_SETS_FAILED */
      });
    }
  }, [n.typeContainer, n.parentId]), i = F(
    async (c, d) => {
      s({
        type: "CREATE_CONCEPT_SET"
        /* CREATE_CONCEPT_SET */
      });
      try {
        const E = await Na(n.typeContainer, n.parentId)({
          name: c.title,
          items: Ge(ir(d))
        });
        s({
          type: "CREATE_CONCEPT_SET_DONE",
          payload: E
        });
      } catch {
      }
    },
    [n]
  ), l = F(
    async (c, d) => {
      s({
        type: "UPDATE_CONCEPT_SET"
        /* UPDATE_CONCEPT_SET */
      });
      try {
        const f = await Ft(
          c.conceptSetId
        ), E = Yt(
          Ge(f.items),
          Ge(ir(d))
        );
        f && await yn(c.conceptSetId, {
          ...f,
          delta: Ra(E, ["add", "replace"])
        }), s({
          type: "UPDATE_CONCEPT_SET_DONE",
          payload: f
        });
      } catch {
      }
    },
    [n]
  ), p = F(
    async (c, d, f = []) => {
      d === Ve.NEW && await i(c, f), d === Ve.EXIST && await l(c, f);
    },
    [n]
  );
  return J(() => {
    e && a(e, t);
  }, []), J(() => {
    o();
  }, [n.typeContainer, n.parentId]), {
    ...n,
    setParams: a,
    conceptSetCreation: p
  };
}, Ja = (e) => {
  const { conceptSets: t, status: n, existConceptSetId: s, setState: a } = e;
  return /* @__PURE__ */ r.jsxs(
    T,
    {
      container: !0,
      item: !0,
      xs: 12,
      md: 4,
      spacing: 1,
      alignItems: "center",
      flexWrap: "nowrap",
      children: [
        /* @__PURE__ */ r.jsx(T, { item: !0, className: "title-saving", width: { xs: 90, md: "auto" }, children: "Concept set" }),
        /* @__PURE__ */ r.jsx(T, { item: !0, display: "flex", flexGrow: 1, children: /* @__PURE__ */ r.jsx(
          hn,
          {
            className: "exist-concept-set",
            disabled: n !== Fe.LOADED_LIST,
            name: "exist-concept-set",
            disablePortal: !0,
            fullWidth: !0,
            id: "exist-concept-set",
            options: t || [],
            value: s,
            placeholder: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
              "Select concept set...",
              " ",
              n === P.IN_PROGRESS && /* @__PURE__ */ r.jsx(ve, { size: 14 })
            ] }),
            onChange: (o) => {
              a((i) => ({
                ...i,
                conceptSetId: o
              }));
            }
          }
        ) })
      ]
    }
  );
}, Ka = (e) => {
  const { title: t, setState: n } = e;
  return /* @__PURE__ */ r.jsxs(T, { container: !0, item: !0, xs: 12, md: 4, spacing: 1, alignItems: "center", children: [
    /* @__PURE__ */ r.jsx(T, { item: !0, className: "title-saving", width: { xs: 90, md: "auto" }, children: "Concept set" }),
    /* @__PURE__ */ r.jsx(T, { item: !0, flexGrow: 1, children: /* @__PURE__ */ r.jsx(
      Le,
      {
        id: "create-new-concept-set",
        name: "title",
        type: "text",
        fullWidth: !0,
        value: t || "",
        onChange: (s) => {
          n((a) => ({
            ...a,
            title: s.target.value
          }));
        }
      }
    ) })
  ] });
};
Ce(de)`
  margin-left: 20px;
  height: 35px;
  font-weight: 700;
  background: #ffffff !important;
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}} !important;
  border: 1px solid ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  text-transform: initial;
`;
Ce(de)`
  color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}} !important;
  border: 1px solid ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
  background: #ffffff !important;
  font-weight: 700;
  border-radius: 4px;
  font-size: 14px;
  height: 35px;
  text-transform: initial;
`;
Ce(Le)`
  border: none !important;
  margin-top: 1px !important;
  margin-left: 30px !important;
  .MuiInputBase-root {
    height: 35px !important;
    line-height: 24px !important;
    padding: 5px 10px !important;
    font-size: 16px !important;
    width: 300px !important;
  }
`;
Ce.div`
  text-align: right;
`;
const Qa = Ce.div`
  /* border-top: 1px solid #e7e7e7; */
  border-bottom: 1px solid ${({ theme: e }) => e.palette.borderColor.main};
  /* box-shadow: -2px 4px 8px -6px #343434; */
  background: #ffffff;
  padding: 8px 16px;

  .title-saving {
    color: ${({ theme: e }) => {
  var t;
  return (t = e.palette) == null ? void 0 : t.primary.main;
}};
    font-weight: 700;
    padding-top: 10px;
    display: inline-block;
    font-size: 14px;
  }
`;
Ce(hn)`
  border: none !important;
  margin-top: 1px !important;
  margin-left: 30px !important;
  width: 300px !important;
  height: 35px !important;
  font-size: 16px !important;
`;
const Xa = Me(
  (e) => {
    const {
      concepts: t,
      subModules: n,
      typeContainer: s,
      parentId: a,
      component: o,
      onSave: i,
      onCancel: l,
      disableActions: p
    } = e, { enqueueSnackbar: c } = ot(), [d, f] = Z(null), [E, h] = Z({
      title: "",
      conceptSetId: "",
      typeContainer: s || b.WORKSPACE,
      parentId: a || null
    }), { status: x, conceptSets: D, setParams: L, conceptSetCreation: N, conceptSet: M } = qa(s, a), $ = (g) => /* @__PURE__ */ r.jsxs(T, { container: !0, spacing: 1, children: [
      /* @__PURE__ */ r.jsxs(T, { item: !0, xs: 12, children: [
        "Concept set ",
        /* @__PURE__ */ r.jsx("b", { children: M.name }),
        " successfully ",
        g
      ] }),
      /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
        bo,
        {
          to: E.typeContainer === b.WORKSPACE ? `/workspace/concept-sets/${M.id}` : `/study-manager/${E.parentId}/concept-sets/${M.id}`,
          children: /* @__PURE__ */ r.jsxs("b", { children: [
            "Navigate to concept set ",
            ">>"
          ] })
        }
      ) })
    ] });
    J(() => {
      (x === Fe.CREATED_SUCCESS || x === Fe.UPDATED_SUCCESS) && (c({
        message: $(
          x === Fe.CREATED_SUCCESS ? "created" : "updated"
        ),
        variant: "success"
      }), f(null), i());
    }, [x, M]);
    const y = B(() => (d === Ve.NEW ? E.title : E.conceptSetId) && (E.typeContainer === b.STUDY ? E.parentId : !0), [E]);
    return /* @__PURE__ */ r.jsx(Qa, { children: /* @__PURE__ */ r.jsxs(T, { container: !0, children: [
      !d && /* @__PURE__ */ r.jsx(T, { container: !0, item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(T, { item: !0, xs: 12, textAlign: "right", children: [
        /* @__PURE__ */ r.jsx(
          de,
          {
            variant: "outlined",
            onClick: () => f(Ve.EXIST),
            disabled: !D.length || p,
            startIcon: x === P.IN_PROGRESS ? /* @__PURE__ */ r.jsx(ve, { size: 14, color: "secondary" }) : /* @__PURE__ */ r.jsx(oe, { iconName: "add" }),
            sx: { mr: 1 },
            children: "Add to existing concept set"
          }
        ),
        /* @__PURE__ */ r.jsx(
          de,
          {
            variant: "outlined",
            onClick: () => f(Ve.NEW),
            startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "add" }),
            disabled: p,
            children: "Create new concept set"
          }
        ),
        o && /* @__PURE__ */ r.jsx(o, {})
      ] }) }),
      d && /* @__PURE__ */ r.jsxs(T, { container: !0, item: !0, xs: 12, children: [
        /* @__PURE__ */ r.jsx(T, { item: !0, flexGrow: 1, children: /* @__PURE__ */ r.jsxs(T, { container: !0, spacing: 2, children: [
          /* @__PURE__ */ r.jsxs(
            T,
            {
              container: !0,
              item: !0,
              xs: 12,
              md: 4,
              spacing: 1,
              alignItems: "center",
              children: [
                /* @__PURE__ */ r.jsx(
                  T,
                  {
                    item: !0,
                    className: "title-saving",
                    width: { xs: 90, md: "auto" },
                    children: "Container"
                  }
                ),
                /* @__PURE__ */ r.jsx(T, { item: !0, flexGrow: 1, children: /* @__PURE__ */ r.jsx(
                  hn,
                  {
                    className: "exist-concept-set",
                    name: "exist-concept-set",
                    disablePortal: !0,
                    fullWidth: !0,
                    id: "exist-concept-set",
                    options: io.filter((g) => g.value !== "ATLAS"),
                    value: E.typeContainer,
                    placeholder: "Select concept set...",
                    onChange: (g) => {
                      L(g, null), h({
                        ...E,
                        title: "",
                        conceptSetId: "",
                        typeContainer: g,
                        parentId: null
                      });
                    }
                  }
                ) })
              ]
            }
          ),
          E.typeContainer === b.STUDY && /* @__PURE__ */ r.jsxs(
            T,
            {
              container: !0,
              item: !0,
              xs: 12,
              md: 4,
              spacing: 1,
              alignItems: "center",
              children: [
                /* @__PURE__ */ r.jsx(
                  T,
                  {
                    item: !0,
                    className: "title-saving",
                    width: { xs: 90, md: "auto" },
                    children: "Study"
                  }
                ),
                /* @__PURE__ */ r.jsx(T, { item: !0, flexGrow: 1, children: /* @__PURE__ */ r.jsx(
                  n.study,
                  {
                    type: "component",
                    name: "user-studies-list",
                    subModules: n,
                    config: {
                      onChange: (g) => {
                        g && (L(E.typeContainer, g.id), h({
                          ...E,
                          title: "",
                          conceptSetId: "",
                          parentId: g.id
                        }));
                      },
                      studyInitialId: a
                    }
                  }
                ) })
              ]
            }
          ),
          d === Ve.EXIST && /* @__PURE__ */ r.jsx(
            Ja,
            {
              typeContainer: E.typeContainer,
              parentId: E.parentId,
              conceptSets: D,
              status: x,
              existConceptSetId: E.conceptSetId,
              setState: h
            }
          ),
          d === Ve.NEW && /* @__PURE__ */ r.jsx(
            Ka,
            {
              setState: h,
              title: E.title
            }
          )
        ] }) }),
        /* @__PURE__ */ r.jsxs(
          T,
          {
            item: !0,
            width: { xs: "100%", md: 200 },
            textAlign: "right",
            mt: { md: 0, xs: 2 },
            children: [
              /* @__PURE__ */ r.jsx(
                de,
                {
                  variant: "outlined",
                  onClick: () => f(null),
                  startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "close" }),
                  children: "Cancel"
                }
              ),
              /* @__PURE__ */ r.jsx(
                de,
                {
                  onClick: () => {
                    N(E, d, t);
                  },
                  disabled: x === Fe.IN_PROGRESS_CREATION || !y,
                  variant: "contained",
                  color: "success",
                  startIcon: x === Fe.IN_PROGRESS_CREATION ? /* @__PURE__ */ r.jsx(ve, { size: 16 }) : /* @__PURE__ */ r.jsx(oe, { iconName: "submit" }),
                  sx: { ml: 1 },
                  children: "Save"
                }
              )
            ]
          }
        )
      ] })
    ] }) });
  }
), Bt = (e) => {
  const {
    message: t = "Included concepts",
    count: n = 0,
    isLoading: s,
    items: a,
    getCount: o,
    versionId: i,
    type: l,
    hideZeroCount: p
  } = e, c = rt(!1), d = rt(null), f = F(
    async (E, h) => {
      if (c.current) {
        d.current = E;
        return;
      }
      c.current = !0, d.current = null;
      try {
        await (o == null ? void 0 : o(h));
      } catch (x) {
        console.error(x);
      } finally {
        c.current = !1, d.current && (d.current = null, await f(d.current, h));
      }
    },
    [o]
  );
  return J(() => {
    f(a, l);
  }, [a, i]), /* @__PURE__ */ r.jsx(
    Ae,
    {
      title: t,
      count: n.toLocaleString(),
      status: s ? P.IN_PROGRESS : P.SUCCESS,
      hideZeroCount: p
    }
  );
}, Za = {
  entityNavigationPanel: (e, t, n, s, a) => [
    {
      value: Pe.EXPRESSION,
      title: "Expression",
      onTabClick: e
    },
    {
      value: Pe.INCLUDED_CONCEPTS,
      title: /* @__PURE__ */ r.jsx(
        Bt,
        {
          count: t.includedConcepts,
          isLoading: t.loadingCountsIncludedConcepts,
          items: s,
          type: _e.INCLUDED_CONCEPTS,
          getCount: n,
          hideZeroCount: !a
        }
      ),
      onTabClick: e
    },
    {
      value: Pe.INCLUDED_SOURCE_CODES,
      title: /* @__PURE__ */ r.jsx(
        Bt,
        {
          count: t.includedSourceCodes,
          isLoading: t.loadingCountsSourceCodes,
          items: s,
          message: "Included source codes",
          type: _e.INCLUDED_SOURCE_CODES,
          getCount: n,
          hideZeroCount: !a
        }
      ),
      onTabClick: e
    }
  ]
}, ei = {
  items: {},
  counts: {
    includedConcepts: 0,
    includedSourceCodes: 0,
    status: P.INITIAL,
    loadingCountsSourceCodes: !1,
    loadingCountsIncludedConcepts: !1
  },
  error: null,
  status: P.INITIAL
};
var xe = /* @__PURE__ */ ((e) => (e.CHECK_CONCEPT_SET = "CHECK_CONCEPT_SET", e.REMOVE_CONCEPT_SET_ITEM = "REMOVE_CONCEPT_SET_ITEM", e.CREATE_CONCEPT_SET_ITEM = "CREATE_CONCEPT_SET_ITEM", e.UPDATE_CONCEPT_SET_ITEMS = "UPDATE_CONCEPT_SET_ITEMS", e.SET_COUNT_REQUEST = "SET_COUNT_REQUEST", e.SET_COUNT_REQUEST_DONE = "SET_COUNT_REQUEST_DONE", e))(xe || {});
const ti = (e, t) => gn(e, (n) => {
  switch (t.type) {
    case xe.CREATE_CONCEPT_SET_ITEM:
      n.status = P.SUCCESS;
      break;
    case xe.UPDATE_CONCEPT_SET_ITEMS:
      n.items = t.payload, n.status = P.SUCCESS;
      break;
    case xe.REMOVE_CONCEPT_SET_ITEM: {
      Xs(t.payload, (s) => s.concept.CONCEPT_ID), n.status = P.SUCCESS;
      break;
    }
    case xe.SET_COUNT_REQUEST:
      n.counts.status = P.IN_PROGRESS, t.payload == _e.INCLUDED_CONCEPTS ? n.counts.loadingCountsIncludedConcepts = !0 : n.counts.loadingCountsSourceCodes = !0;
      break;
    case xe.SET_COUNT_REQUEST_DONE:
      if (n.counts.status = P.SUCCESS, t.payload.reset) {
        n.counts.includedConcepts = 0, n.counts.includedSourceCodes = 0, n.counts.loadingCountsIncludedConcepts = !1, n.counts.loadingCountsSourceCodes = !1;
        break;
      }
      t.payload.typeOfIncluded == _e.INCLUDED_CONCEPTS ? (n.counts.loadingCountsIncludedConcepts = !1, n.counts.includedConcepts = t.payload.count) : (n.counts.loadingCountsSourceCodes = !1, n.counts.includedSourceCodes = t.payload.count);
  }
}), ni = (e, t) => {
  const [n, s] = fn(
    ti,
    {
      ...ei,
      items: t
    }
  ), a = (c) => {
    s({
      type: xe.UPDATE_CONCEPT_SET_ITEMS,
      payload: c
    });
  }, o = F(() => {
    if (!n.items || !t)
      return [];
    const c = {
      items: Ge(t)
    }, d = {
      items: Ge(n.items)
    }, f = Yt(c, d);
    return zr(f, d.items);
  }, [n.items]), i = F(
    (c, d) => {
      try {
        return Mr(d, c, e.uuid, {
          delta: o()
        });
      } catch (f) {
        console.error(f);
      }
    },
    [n.items]
  ), l = F(
    (c, d) => {
      try {
        return Ur(
          d,
          c,
          e.uuid,
          {
            delta: o()
          }
        );
      } catch (f) {
        console.error(f);
      }
    },
    [n.items]
  ), p = F(
    async (c) => {
      if (Object.values(n.items || {}).length) {
        s({
          type: xe.SET_COUNT_REQUEST,
          payload: c
        });
        try {
          if (!e.uuid) {
            s({
              type: xe.SET_COUNT_REQUEST_DONE,
              payload: {
                typeOfIncluded: c,
                count: 0
              }
            });
            return;
          }
          const d = c == _e.INCLUDED_CONCEPTS ? await Dr(e.uuid, {
            delta: o()
          }) : await Lr(e.uuid, {
            delta: o()
          });
          s({
            type: xe.SET_COUNT_REQUEST_DONE,
            payload: {
              typeOfIncluded: c,
              count: d
            }
          });
        } catch {
          s({
            type: xe.SET_COUNT_REQUEST_DONE,
            payload: {
              typeOfIncluded: c,
              count: 0
            }
          });
        }
      } else
        s({
          type: xe.SET_COUNT_REQUEST_DONE,
          payload: {
            reset: !0
          }
        });
    },
    [n.items]
  );
  return {
    ...n,
    getCountIncluded: p,
    updateConceptSetItems: a,
    getIncludedConcepts: i,
    getIncludedConceptsFilters: l
  };
}, ri = (e) => {
  const {
    conceptSet: t,
    conceptSetItems: n = [],
    subModules: s,
    updateModel: a,
    // path,
    viewMode: o
  } = e, [i, l] = Z(
    Pe.EXPRESSION
  ), { entityNavigationPanel: p } = Za, c = xr(), [d, f] = Z("");
  J(() => {
    f(
      c.pathname[0] === "/" ? c.pathname.substring(1) : c.pathname
    );
  }, []);
  const E = B(() => ft(n), [n]), {
    counts: h,
    items: x,
    status: D,
    getCountIncluded: L,
    getIncludedConcepts: N,
    updateConceptSetItems: M,
    getIncludedConceptsFilters: $
  } = ni(t, E), y = B(() => p(
    l,
    h,
    L,
    x,
    t.uuid
  ), [h, x, t]), g = (A) => {
    o || M(A);
  };
  J(() => {
    !o && D !== P.INITIAL && a(wt(x));
  }, [x, D, o]);
  const v = () => {
    l(Pe.EXPRESSION);
  };
  return /* @__PURE__ */ r.jsxs(T, { container: !0, children: [
    /* @__PURE__ */ r.jsxs(
      T,
      {
        item: !0,
        xs: 12,
        bgcolor: "white",
        sx: { borderTopRightRadius: "2px", borderTopLeftRadius: "2px" },
        children: [
          /* @__PURE__ */ r.jsx(xn, { tabs: y, active: i, secondary: !0 }),
          /* @__PURE__ */ r.jsx(En, {})
        ]
      }
    ),
    /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, mt: 2, children: D === P.IN_PROGRESS ? /* @__PURE__ */ r.jsx(De, { children: /* @__PURE__ */ r.jsx(ve, { size: 32 }) }) : /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      i == Pe.EXPRESSION && /* @__PURE__ */ r.jsx(
        s.vocabulary,
        {
          type: "component",
          name: "expression-concepts",
          path: d,
          subModules: s,
          config: {
            concepts: x,
            onChange: g,
            viewMode: o,
            mode: "embedded"
          }
        }
      ),
      i == Pe.INCLUDED_CONCEPTS && /* @__PURE__ */ r.jsx(
        s.vocabulary,
        {
          type: "component",
          name: "included-concepts",
          subModules: s,
          path: d,
          config: {
            concepts: x,
            methodIncluded: N,
            filtersIncluded: $,
            onChange: g,
            onFinish: v,
            viewMode: o
          }
        }
      ),
      i == Pe.INCLUDED_SOURCE_CODES && /* @__PURE__ */ r.jsx(
        s.vocabulary,
        {
          type: "component",
          name: "included-concepts-source-codes",
          subModules: s,
          path: d,
          config: {
            concepts: x,
            methodIncluded: N,
            filtersIncluded: $,
            onChange: g,
            onFinish: v,
            viewMode: o
          }
        }
      )
    ] }) })
  ] });
}, si = (e) => {
  var t, n;
  return (e == null ? void 0 : e.ordinal) ?? ((t = e == null ? void 0 : e.data) == null ? void 0 : t.versionOrdinal) ?? ((n = e == null ? void 0 : e.data) == null ? void 0 : n.version) ?? (e == null ? void 0 : e.versionOrdinal) ?? (e == null ? void 0 : e.version) ?? null;
}, oi = (e) => {
  if (!e)
    return "none";
  const t = !!(e.referenceId || e.versionId || e.currentVersionId);
  return !t && !e.terminated ? "none" : e.terminated || t && !e.currentVersionId ? "archived" : e.versionId && e.currentVersionId && e.currentVersionId !== e.versionId ? "outdated" : "none";
}, _t = ({ label: e, color: t, icon: n }) => {
  const s = {
    warning: {
      backgroundColor: "#fff1dd",
      color: "#f2a53a"
    },
    info: {
      backgroundColor: "#d6eafb",
      color: "#64a7df"
    },
    default: {
      backgroundColor: "#dfdfdf",
      color: "#8f8f8f"
    }
  };
  return /* @__PURE__ */ r.jsxs(
    ge,
    {
      display: "inline-flex",
      alignItems: "center",
      px: 1.25,
      height: 26,
      borderRadius: 1,
      sx: {
        ...s[t],
        lineHeight: 1
      },
      children: [
        n,
        /* @__PURE__ */ r.jsx(ye, { component: "span", fontSize: 14, sx: { lineHeight: 1 }, children: e })
      ]
    }
  );
}, lr = /* @__PURE__ */ r.jsx(
  ge,
  {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    mr: 0.75,
    width: 16,
    height: 16,
    borderRadius: "50%",
    sx: {
      border: "2px solid currentColor"
    },
    children: /* @__PURE__ */ r.jsx(
      oe,
      {
        iconName: "info",
        sx: {
          color: "inherit",
          fontSize: 16,
          "& circle": {
            fill: "transparent",
            fillOpacity: 1
          }
        }
      }
    )
  }
), ai = /* @__PURE__ */ r.jsx(oe, { iconName: "reload", sx: { color: "inherit", fontSize: 16, mr: 0.75 } }), ii = ({ conceptSet: e, viewMode: t = !1, onRefresh: n }) => {
  const s = B(() => oi(e), [e]), [a, o] = Z(null);
  if (J(() => {
    let h = !0;
    return (s === "outdated" || s === "archived") && ((e == null ? void 0 : e.versionOrdinal) === void 0 || (e == null ? void 0 : e.versionOrdinal) === null) && ((e == null ? void 0 : e.version) === void 0 || (e == null ? void 0 : e.version) === null) && (e != null && e.versionId) && kr(e.versionId).then((x) => {
      const D = si(x);
      h && D !== null && o(D);
    }).catch(() => {
    }), () => {
      h = !1;
    };
  }, [
    e == null ? void 0 : e.version,
    e == null ? void 0 : e.versionId,
    e == null ? void 0 : e.versionOrdinal,
    s
  ]), !e || s === "none")
    return null;
  const i = e.versionOrdinal ?? e.version ?? a, l = i != null, p = !!(!t && s === "outdated" && n && e.currentVersionId), c = e.currentVersionOrdinal, d = /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    "Newer version exists",
    c != null ? ` (latest version: ${c})` : "",
    ",",
    /* @__PURE__ */ r.jsx("br", {}),
    " would you like to REFRESH it?"
  ] }), f = (h) => {
    h.preventDefault(), h.stopPropagation();
  }, E = (h) => {
    h.preventDefault(), h.stopPropagation(), n == null || n(e);
  };
  return /* @__PURE__ */ r.jsxs(
    ge,
    {
      display: "inline-flex",
      alignItems: "center",
      flexWrap: "nowrap",
      ml: 1.5,
      sx: {
        whiteSpace: "nowrap",
        alignSelf: "center",
        lineHeight: 1
      },
      children: [
        l && /* @__PURE__ */ r.jsxs(
          ye,
          {
            variant: "subtitle1",
            component: "i",
            sx: { mr: 2, fontWeight: 400, whiteSpace: "nowrap" },
            children: [
              "( Version: ",
              i,
              " )"
            ]
          }
        ),
        s === "archived" && /* @__PURE__ */ r.jsx(
          _t,
          {
            color: "default",
            label: "Archived",
            icon: /* @__PURE__ */ r.jsx(
              oe,
              {
                iconName: "terminated",
                sx: { color: "inherit", fontSize: 16, mr: 0.75 }
              }
            )
          }
        ),
        s === "outdated" && (p ? /* @__PURE__ */ r.jsx(mt, { text: d, children: /* @__PURE__ */ r.jsxs(
          ge,
          {
            role: "button",
            tabIndex: 0,
            onClick: E,
            onKeyDown: (h) => {
              (h.key === "Enter" || h.key === " ") && E(h);
            },
            onMouseDown: f,
            onPointerDown: f,
            onTouchStart: f,
            sx: {
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              lineHeight: 1,
              ".refresh-chip": {
                display: "none"
              },
              "&:hover": {
                ".outdated-chip": {
                  display: "none"
                },
                ".refresh-chip": {
                  display: "inline-flex"
                }
              }
            },
            children: [
              /* @__PURE__ */ r.jsx(ge, { className: "outdated-chip", sx: { display: "inline-flex" }, children: /* @__PURE__ */ r.jsx(
                _t,
                {
                  color: "warning",
                  label: "Outdated",
                  icon: lr
                }
              ) }),
              /* @__PURE__ */ r.jsx(ge, { className: "refresh-chip", sx: { display: "inline-flex" }, children: /* @__PURE__ */ r.jsx(_t, { color: "info", label: "Refresh", icon: ai }) })
            ]
          }
        ) }) : /* @__PURE__ */ r.jsx(_t, { color: "warning", label: "Outdated", icon: lr }))
      ]
    }
  );
}, ci = (e) => [
  {
    value: "ITEMS",
    title: "Concept Set Expression",
    onTabClick: e
  },
  {
    value: "CONCEPT_IDS",
    title: "Expression Concept Identifiers",
    onTabClick: e
  },
  {
    value: "CONCEPT_INCLUDED_IDS",
    title: "Included Concept Identifiers",
    onTabClick: e
  },
  {
    value: "CONCEPT_INCLUDED_CODES",
    title: "Included Concept Codes (Source)",
    onTabClick: e
  }
], qr = Me((e) => {
  const { id: t, title: n = "" } = e, [s, a] = Z("ITEMS"), {
    exportConceptSet: o,
    exportConceptSetIds: i,
    exportConceptSetCodes: l,
    statusExportConceptSet: p,
    statusExportConceptSetIds: c,
    getExportConceptSet: d
  } = Ps(Rt.CONCEPT_SET, t, null), f = B(() => {
    var $;
    if (o && p === P.SUCCESS) {
      const y = (($ = o == null ? void 0 : o.expression) == null ? void 0 : $.items) || (o == null ? void 0 : o.items) || {};
      return {
        expression: {
          items: y
        },
        conceptIds: Object.values(y || {}).map(
          (g) => {
            var v;
            return g.conceptId || ((v = g.concept) == null ? void 0 : v.CONCEPT_ID);
          }
        )
      };
    }
  }, [o]), E = B(
    () => f == null ? void 0 : f.expression,
    [f == null ? void 0 : f.expression]
  ), h = B(
    () => f && f.conceptIds.join(", "),
    [f == null ? void 0 : f.conceptIds]
  ), x = B(
    () => i && c === P.SUCCESS && i.join(", "),
    [i]
  ), D = B(
    () => l && c === P.SUCCESS && l.join(", "),
    [l]
  ), L = B(
    () => Jn(ke.JSON),
    []
  ), N = B(
    () => Jn(ke.TXT),
    []
  ), M = B(() => ci(a), []);
  return J(() => {
    d("atlas");
  }, []), /* @__PURE__ */ r.jsxs(T, { container: !0, children: [
    /* @__PURE__ */ r.jsxs(T, { item: !0, xs: 12, children: [
      /* @__PURE__ */ r.jsx(xn, { tabs: M, active: s, secondary: !0 }),
      /* @__PURE__ */ r.jsx(En, {})
    ] }),
    /* @__PURE__ */ r.jsxs(T, { item: !0, xs: 12, p: 2, children: [
      s === "ITEMS" && /* @__PURE__ */ r.jsx(r.Fragment, { children: p === P.SUCCESS && E ? /* @__PURE__ */ r.jsx(
        vt,
        {
          data: E,
          fileName: n,
          title: "Concept Set Expression",
          language: L,
          fileExtension: ke.JSON,
          contentType: pt.APPLICATION_JSON,
          readOnly: !0,
          height: 450,
          editorOptions: {
            wrappingStrategy: "simple"
          }
        }
      ) : /* @__PURE__ */ r.jsx(De, { children: /* @__PURE__ */ r.jsx(ve, { size: 32 }) }) }),
      s === "CONCEPT_IDS" && /* @__PURE__ */ r.jsx(r.Fragment, { children: h && /* @__PURE__ */ r.jsx(
        vt,
        {
          data: h,
          fileName: `${n} (Expression Concept Identifiers)`,
          title: "Expression Concept Identifiers",
          tooltipText: "Expression Concept Identifiers copied to clipboard!",
          contentType: pt.APPLICATION_TEXT,
          fileExtension: ke.TXT,
          language: N,
          height: 450,
          containerStyles: {
            paddingTop: 0
          },
          editorOptions: {
            wrappingStrategy: "simple"
          },
          readOnly: !0
        }
      ) }),
      s === "CONCEPT_INCLUDED_IDS" && /* @__PURE__ */ r.jsx(r.Fragment, { children: x && /* @__PURE__ */ r.jsx(
        vt,
        {
          data: x,
          fileName: `${n} (Included Concept Identifiers)`,
          title: "Included Concept Identifiers",
          tooltipText: "Included Concept Identifiers copied to clipboard!",
          contentType: pt.APPLICATION_TEXT,
          fileExtension: ke.TXT,
          language: N,
          height: 450,
          containerStyles: {
            paddingTop: 0
          },
          editorOptions: {
            wrappingStrategy: "simple"
          },
          readOnly: !0
        }
      ) }),
      s === "CONCEPT_INCLUDED_CODES" && /* @__PURE__ */ r.jsx(r.Fragment, { children: D && /* @__PURE__ */ r.jsx(
        vt,
        {
          data: D,
          fileName: `${n} (Included Concept Codes (Source))`,
          title: "Included Concept Codes (Source)",
          tooltipText: "Included Concept Codes (Source) copied to clipboard!",
          contentType: pt.APPLICATION_TEXT,
          fileExtension: ke.TXT,
          language: N,
          height: 450,
          containerStyles: {
            paddingTop: 0
          },
          editorOptions: {
            wrappingStrategy: "simple"
          },
          readOnly: !0
        }
      ) })
    ] })
  ] });
}), li = (e) => {
  const {
    conceptSets: t,
    onChange: n,
    conceptSetNameErrors: s,
    onConceptSetNameSubmit: a,
    onConceptSetNameCancel: o,
    subModules: i,
    typeContainer: l,
    parentId: p,
    viewMode: c,
    analysisMode: d,
    exportConceptSet: f,
    circleMode: E,
    refreshConceptSetReference: h,
    hideSectionContent: x,
    renderSectionTitleAddon: D,
    onEditSection: L,
    onAddConceptSet: N,
    hideAddConceptSetAction: M = !1,
    hideCopySectionAction: $ = !1,
    hideEditSectionAction: y = !1
  } = e, [g, v] = Z(!1), { openModal: A, closeModal: U } = Ie(He), {
    sections: Y,
    addSection: ie,
    copySection: K,
    updateSection: S,
    removeSection: R,
    exportSection: q,
    syncSections: W
  } = Ds(t || []), Q = F(
    (u) => ({
      id: u.id,
      name: u.name,
      uuid: u == null ? void 0 : u.uuid,
      expression: u.expression,
      referenceId: u == null ? void 0 : u.referenceId,
      externalId: u == null ? void 0 : u.externalId,
      versionId: u == null ? void 0 : u.versionId,
      currentVersionId: u == null ? void 0 : u.currentVersionId,
      version: u == null ? void 0 : u.version,
      versionOrdinal: u == null ? void 0 : u.versionOrdinal,
      currentVersionOrdinal: u == null ? void 0 : u.currentVersionOrdinal,
      terminated: u == null ? void 0 : u.terminated
    }),
    []
  ), he = F(
    (u) => ({
      id: u.id,
      name: u.name,
      uuid: u == null ? void 0 : u.uuid,
      expression: u.expression,
      referenceId: u == null ? void 0 : u.referenceId,
      externalId: u == null ? void 0 : u.externalId,
      versionId: u == null ? void 0 : u.versionId,
      currentVersionId: u == null ? void 0 : u.currentVersionId,
      version: u == null ? void 0 : u.version,
      versionOrdinal: u == null ? void 0 : u.versionOrdinal,
      currentVersionOrdinal: u == null ? void 0 : u.currentVersionOrdinal,
      terminated: u == null ? void 0 : u.terminated
    }),
    []
  ), V = B(
    () => Y.map(
      (u) => Q(u)
    ),
    [Y, Q]
  ), ue = B(
    () => Y.map(
      (u) => he(u)
    ),
    [Y, he]
  );
  B(
    () => (t || []).map(
      (u) => Q(u)
    ),
    [Q, t]
  );
  const C = B(
    () => (t || []).map(
      (u) => he(u)
    ),
    [he, t]
  ), j = rt(ue), z = rt(!1);
  J(() => {
    j.current = ue;
  }, [ue]), J(() => {
    Pt(j.current, C) || (z.current = !0, W(t || []));
  }, [C, W, t]);
  const G = (u) => {
    A(
      () => /* @__PURE__ */ r.jsx(
        gr,
        {
          id: u.uuid,
          name: u.name,
          parentId: p,
          currentContainer: l,
          subModules: i,
          jsonImportTabName: "Concept Set Items",
          createCopyMethod: Fr,
          typeEntity: "concept-sets",
          entityAtlas: ht.CS,
          defaultResolution: te.CREATE_NEW_OBJECT,
          hideConflictResolutionControls: !0,
          validateName: async (ne) => ne.typeContainer === b.WORKSPACE ? ze(
            b.WORKSPACE,
            ne.name
          ) : ne.typeContainer === b.STUDY ? ne.studyId ? ze(
            b.STUDY,
            ne.name,
            String(ne.studyId)
          ) : {
            isValid: !1,
            message: "Study is required."
          } : { isValid: !0 },
          onChange: () => {
            U();
          },
          exportJson: /* @__PURE__ */ r.jsx(qr, { id: u.uuid || u.id, title: u.name }),
          customAction: /* @__PURE__ */ r.jsx(
            "a",
            {
              href: `/api/conceptset/${u.uuid}/included/csv-zip`,
              target: "_blank",
              children: /* @__PURE__ */ r.jsx(
                de,
                {
                  variant: "contained",
                  color: "success",
                  size: "small",
                  startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "export" }),
                  children: "Export to CSV"
                }
              )
            }
          )
        }
      ),
      "Export concept set",
      {
        closeOnClickOutside: !0,
        onClose: U
      }
    );
  };
  J(() => {
    if (Pt(
      ue,
      C
    )) {
      z.current = !1;
      return;
    }
    z.current || n == null || n(V);
  }, [
    d,
    V,
    ue,
    C,
    n
  ]);
  const me = F(
    async (u) => {
      h && await h(u);
    },
    [h]
  ), pe = async () => {
    if (!N) {
      ie({
        id: null,
        name: "New Concept set",
        expression: { items: [] }
      });
      return;
    }
    v(!0);
    try {
      const u = await N();
      u && ie(u);
    } finally {
      v(!1);
    }
  };
  return /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(
    Wt,
    {
      outlined: !0,
      title: "Concept sets",
      actions: c ? void 0 : /* @__PURE__ */ r.jsxs(ge, { display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ r.jsx(
          Vr,
          {
            defaultValue: "Import concept set",
            localImport: !1,
            importMultiSelect: !0,
            conceptSets: t,
            typeContainer: l,
            parentId: p,
            subModules: i,
            simpleButtonMode: !0,
            dense: !1,
            circleMode: E,
            onUpdate: (u) => {
              ie(u);
            }
          }
        ),
        !M && /* @__PURE__ */ r.jsx(
          de,
          {
            variant: "contained",
            color: "info",
            onClick: pe,
            disabled: g,
            startIcon: g ? /* @__PURE__ */ r.jsx(ve, { size: 16 }) : /* @__PURE__ */ r.jsx(
              oe,
              {
                iconName: "add",
                sx: { "&.MuiSvgIcon-root": { fontSize: 16 } }
              }
            ),
            sx: { ml: 2 },
            children: "Add concept set"
          }
        )
      ] }),
      children: /* @__PURE__ */ r.jsx(T, { container: !0, children: /* @__PURE__ */ r.jsx(T, { container: !0, spacing: 1, alignItems: "center", children: Y.length > 0 && Y.map(
        (u, ne) => {
          const ee = (u == null ? void 0 : u.uuid) ?? (u == null ? void 0 : u.id) ?? (u == null ? void 0 : u.referenceId) ?? `${(u == null ? void 0 : u.name) || "section"}-${ne}`;
          return /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
            So,
            {
              index: ne,
              viewMode: c,
              item: u,
              titleMeta: D ? null : /* @__PURE__ */ r.jsx(
                ii,
                {
                  conceptSet: u,
                  viewMode: c,
                  onRefresh: (H) => me(
                    H
                  )
                }
              ),
              copySection: K,
              onCancelSectionName: (H) => {
                o == null || o(H);
              },
              updateSection: async (H, I, Ee) => I === "name" && (typeof Ee != "string" || !(await (a == null ? void 0 : a(
                H,
                Ee
              )) ?? !0)) ? !1 : (S(H, I, Ee), !0),
              removeSection: R,
              nameError: s == null ? void 0 : s[String(ne)],
              exportSection: (H) => {
                const I = q(H);
                G(I);
              },
              isExport: f,
              bodyViewMode: x,
              disableNameEdit: x,
              titleAddon: D == null ? void 0 : D(
                u,
                ne,
                {
                  onRefreshReference: (H) => me(H)
                }
              ),
              onEdit: L ? (H, I) => {
                L(
                  H,
                  I
                );
              } : void 0,
              hideCopyAction: $,
              hideEditAction: y,
              children: /* @__PURE__ */ r.jsx(
                ri,
                {
                  viewMode: c || x,
                  conceptSet: u,
                  conceptSetItems: u.expression.items,
                  subModules: i,
                  updateModel: (H) => {
                    S(ne, "expression", {
                      items: H
                    });
                  }
                }
              )
            }
          ) }, String(ee));
        }
      ) }) })
    }
  ) });
}, di = (e) => {
  var a;
  const { conceptSets: t, conceptSetId: n } = e, s = B(
    () => tn(n, t || []),
    [n, t]
  );
  return /* @__PURE__ */ r.jsx(T, { container: !0, children: /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
    Wr,
    {
      currentConceptSet: {
        ...s,
        expression: {
          items: ft(
            ((a = s == null ? void 0 : s.expression) == null ? void 0 : a.items) || []
          )
        }
      },
      conceptSets: t.map((o) => {
        var i;
        return {
          ...o,
          expression: {
            items: ft(
              ((i = o == null ? void 0 : o.expression) == null ? void 0 : i.items) || []
            )
          }
        };
      }),
      viewMode: !0
    }
  ) }) });
}, ui = "&filter.metadata.subject=CONCEPT_SET", dr = te.CREATE_NEW_VERSION, pi = te.CREATE_NEW_OBJECT, mi = "Fully identical concept sets will not be created, instead existing ones will be re-used. Concept sets with the same name will create a new version of the existing ones and Cohort design will reference these newly created versions. Previously created concept-sets, which are not used anywhere else will be deleted(archived).", fi = "New Concept Set(s) will be created, even if identical Concept Set(s) exist.", ut = (e) => e.trim().replace(/^['"]|['"]$/g, "").replace(/^\[+/, "").replace(/\]+$/, "").trim(), Ot = (e) => {
  if (Array.isArray(e))
    return e.map((t) => ut(String(t))).filter(Boolean);
  if (typeof e == "string") {
    const t = e.trim();
    if (!t) return [];
    try {
      const n = JSON.parse(t);
      if (Array.isArray(n))
        return n.map((s) => ut(String(s))).filter(Boolean);
    } catch {
    }
    if (t.startsWith("[") && t.endsWith("]")) {
      const n = t.slice(1, -1).trim();
      return n ? n.split(",").map(ut).filter(Boolean) : [];
    }
    return t.includes(",") ? t.split(",").map(ut).filter(Boolean) : [ut(t)].filter(Boolean);
  }
  return [];
}, Ci = (e) => {
  if (!e) return {};
  if (typeof e == "string") {
    try {
      const t = JSON.parse(e);
      if (t && typeof t == "object" && !Array.isArray(t))
        return t;
    } catch {
      return { Description: e };
    }
    return { Description: e };
  }
  return e;
}, en = (e) => typeof e == "string" ? e : e.name, ur = (e) => {
  if (typeof e == "boolean")
    return e;
  if (typeof e == "string") {
    const t = e.trim().toLowerCase();
    if (t === "true")
      return !0;
    if (t === "false")
      return !1;
  }
}, Nt = (e) => {
  if (typeof e == "number" && Number.isFinite(e))
    return e;
  if (typeof e == "string" && e.trim() !== "") {
    const t = Number(e);
    if (Number.isFinite(t))
      return t;
  }
}, nt = (e, t) => {
  var a;
  const n = t.map((o) => o.toLowerCase()), s = e == null ? void 0 : e.find((o) => {
    var l, p;
    const i = (p = (l = o.attribute) == null ? void 0 : l.name) == null ? void 0 : p.toLowerCase();
    return i ? n.includes(i) : !1;
  });
  return ((a = s == null ? void 0 : s.value) == null ? void 0 : a.trim()) || "";
}, hi = (e, t) => {
  const n = Nt(e["Search precision"]) ?? Nt(
    nt(t, [
      "Search precision",
      "ai-search-precision"
    ])
  );
  if (n !== void 0 && n >= 0 && n < jt.length)
    return n;
  const s = ur(e["~ai_skip_vector_search"]) ?? ur(
    nt(t, [
      "~ai_skip_vector_search",
      "ai_skip_vector_search",
      "ai-skip-vector-search"
    ])
  ), a = Nt(e["~vector_search_result_limit"]) ?? Nt(
    nt(t, [
      "~vector_search_result_limit",
      "vector_search_result_limit",
      "ai-vector-search-result-limit"
    ])
  ), o = jt.findIndex(
    (i) => i.skipVectorSearch === s && i.vectorSearchResultLimit === a
  );
  return o >= 0 ? o : 0;
}, Ei = Ce.div`
  padding-top: 12px;
  border-top: 1px solid ${({ theme: e }) => e.palette.backgroundColor.dark};
`, gi = Ce.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: rgb(133, 133, 133);
  font-size: 15px;
  font-weight: 500;

  .app-checkbox {
    margin-right: 10px;
  }
`, Jr = Me(
  ({
    parentId: e,
    typeContainer: t,
    afterCreate: n,
    onCancel: s,
    onGenerateStart: a,
    onGenerateError: o,
    createMethod: i,
    entity: l,
    prompt: p,
    attributes: c
  }) => {
    var u, ne, ee, H, I, Ee;
    const { enqueueSnackbar: d } = ot(), f = !!l, [E, h] = Z(!1), [x, D] = Z(""), [L, N] = Z(!1), M = rt(0), $ = rt(!1), [y, g] = Z(dr), v = Ci(p), A = (w, _) => Ot(w).map((fe) => ({ name: (_ == null ? void 0 : _.get(fe)) ?? fe, value: fe })), U = F(
      async (w, _) => {
        const [ae, fe] = await Promise.all([
          ea(ui),
          Dt(
            "filter.metadata.value.subject.id",
            w
          )
        ]), ce = ae.content.find(
          (Oe) => Oe.name === "ai-prompt"
        );
        if (!ce)
          return;
        const re = fe.content.find(
          (Oe) => {
            var St;
            return ((St = Oe.attribute) == null ? void 0 : St.name) === "ai-prompt";
          }
        ), Je = JSON.stringify({
          Description: _.description,
          Domain: _.domain,
          Vocabulary: _.vocabulary,
          "Standard concept": _.standardConcept,
          "Search precision": _.searchPrecision,
          "~ai_skip_vector_search": _.skipVectorSearch,
          "~vector_search_result_limit": _.vectorSearchResultLimit,
          "Conflict resolution": _.conflictResolution
        }), le = {
          attribute: { id: ce.id },
          dataSourceId: w,
          value: Je
        };
        if (re != null && re.id) {
          await an(le, re.id);
          return;
        }
        await on(le);
      },
      []
    ), Y = Ot(v.Domain).length > 0 ? v.Domain : nt(c, ["Domain", "ai-domains"]), ie = Ot(v.Vocabulary).length > 0 ? v.Vocabulary : nt(c, [
      "Vocabulary",
      "ai-vocabularies"
    ]), K = Ot(v["Standard concept"]).length > 0 ? v["Standard concept"] : nt(c, [
      "Standard concept",
      "ai-standard-concepts"
    ]), [S, R] = Z({
      text: v.Description || "",
      concept_set_name: (l == null ? void 0 : l.name) || "",
      vocabulary: A(ie),
      domain: A(Y),
      standard_concept: A(
        K,
        new Map(
          Array.from(co, ([w, _]) => [
            w,
            _.caption
          ])
        )
      ),
      model_id: "",
      search_precision: hi(v, c),
      suggestion: !1
    }), q = Ls(i, e, l, "conceptset"), { options: W, status: Q } = Ms(), { options: he, status: V } = Us(), ue = F(
      (w) => {
        const { name: _, value: ae } = w.target;
        R((fe) => ({ ...fe, [_]: ae }));
      },
      []
    ), C = F(
      (w, _) => {
        R((ae) => ({ ...ae, [w]: _ }));
      },
      []
    ), j = F(
      async (w) => {
        if (!(E || Object.values(S).every(bt))) {
          h(!0);
          try {
            if (!l) {
              const le = await ze(
                t,
                S.concept_set_name,
                e
              );
              if (!le.isValid) {
                D(le.message || ""), h(!1);
                return;
              }
            }
            D(""), a ? a() : d({
              message: l ? "Concept set regenerate in progress..." : "Concept set generate in progress...",
              variant: "success"
            });
            const _ = jt[S.search_precision] ?? jt[0], ae = S.domain.map((le) => le.value), fe = S.vocabulary.map((le) => le.value), ce = S.standard_concept.map(
              (le) => le.value
            );
            let re = !1;
            const Je = await q.generate(
              {
                title: S.concept_set_name,
                description: S.text,
                domain: ae,
                vocabulary: fe,
                standardConcept: ce,
                conflictResolution: w,
                skipVectorSearch: _.skipVectorSearch,
                vectorSearchResultLimit: _.vectorSearchResultLimit,
                suggestion: S.suggestion
              },
              (le) => {
                re = !0, n(le);
              }
            );
            try {
              await U(Je.id, {
                description: S.text,
                domain: ae,
                vocabulary: fe,
                standardConcept: ce,
                searchPrecision: S.search_precision,
                skipVectorSearch: _.skipVectorSearch,
                vectorSearchResultLimit: _.vectorSearchResultLimit,
                conflictResolution: w
              });
            } catch (le) {
              console.error("Error updating ai-prompt metadata:", le);
            }
            re || n(Je);
          } catch (_) {
            o == null || o(), d({
              message: "Concept set not created",
              variant: "error"
            }), console.error("Error:", _);
          } finally {
            h(!1);
          }
        }
      },
      [
        S,
        E,
        n,
        l,
        t,
        e,
        q,
        U,
        d,
        a,
        o
      ]
    ), z = F(() => {
      g(dr), N(!0);
    }, []), G = F(() => {
      N(!1), $.current = !1, Xt("dialog") >= M.current && ks();
    }, []);
    J(() => {
      if (L && !$.current) {
        const w = Xt("dialog") + 1;
        M.current = w, $s("dialog", w);
      }
      $.current = L;
    }, [L]), J(() => Bs((_) => {
      L && Xt("dialog", _.state) < M.current && N(!1);
    }), [L]);
    const me = F(async () => {
      G(), await j(y);
    }, [G, y, j]), pe = F(() => {
      if (f) {
        z();
        return;
      }
      j(pi);
    }, [f, z, j]);
    return J(() => {
      if (V === P.SUCCESS) {
        const w = he.find((_) => _.isDefault);
        R((_) => ({ ..._, model_id: w == null ? void 0 : w.value }));
      }
    }, [V]), [P.INITIAL, P.IN_PROGRESS].includes(Q) || [P.INITIAL, P.IN_PROGRESS].includes(V) ? /* @__PURE__ */ r.jsx(De, { children: /* @__PURE__ */ r.jsx(ve, {}) }) : /* @__PURE__ */ r.jsxs(
      T,
      {
        container: !0,
        p: 2,
        sx: { width: "100%", maxWidth: "100%", overflowX: "hidden" },
        children: [
          /* @__PURE__ */ r.jsx(Cn, { elevated: !0, outlined: !0, children: /* @__PURE__ */ r.jsxs(
            T,
            {
              container: !0,
              rowSpacing: 2,
              columnSpacing: 0,
              p: 2,
              sx: { width: "100%", m: 0, "& > .MuiGrid-item": { minWidth: 0 } },
              children: [
                /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(we, { name: "name", textLabel: "Name", required: !0, children: [
                  /* @__PURE__ */ r.jsx(
                    Le,
                    {
                      id: "name",
                      name: "concept_set_name",
                      type: "text",
                      size: "medium",
                      value: S.concept_set_name,
                      disabled: !!l,
                      placeholder: "Enter name",
                      onChange: (w) => {
                        D(""), ue(w);
                      },
                      fullWidth: !0
                    }
                  ),
                  x && /* @__PURE__ */ r.jsx(ye, { color: "error.main", variant: "caption", children: x })
                ] }) }),
                /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(we, { name: "description", textLabel: "Description", required: !0, children: /* @__PURE__ */ r.jsx(
                  Le,
                  {
                    id: "description",
                    name: "text",
                    type: "text",
                    size: "medium",
                    value: S.text,
                    placeholder: "Enter description (prompt for generation).",
                    onChange: ue,
                    fullWidth: !0,
                    multiline: !0,
                    minRows: 6,
                    maxRows: 20
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(T, { item: !0, xs: 6, children: /* @__PURE__ */ r.jsx(we, { name: "domain", textLabel: "Domain", children: /* @__PURE__ */ r.jsx(
                  Qt,
                  {
                    id: "domain",
                    name: "domain",
                    options: ((u = W == null ? void 0 : W.domains) == null ? void 0 : u.filter(
                      (w) => {
                        var _;
                        return !((_ = S.domain) != null && _.some(
                          (ae) => ae.value === w.value
                        ));
                      }
                    )) || [],
                    value: S.domain,
                    multiple: !0,
                    placeholder: (ne = S.domain) != null && ne.length ? "" : "Any",
                    onChange: (w, _) => {
                      C("domain", _);
                    },
                    fullWidth: !0,
                    isOptionEqualToValue: (w, _) => w.value === _,
                    getOptionLabel: en
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(T, { item: !0, xs: 6, sx: { pl: 2 }, children: /* @__PURE__ */ r.jsx(we, { name: "standard_concept", textLabel: "Standard Concept", children: /* @__PURE__ */ r.jsx(
                  Qt,
                  {
                    id: "standard_concept",
                    name: "standard_concept",
                    options: ((ee = W == null ? void 0 : W.standard_concepts) == null ? void 0 : ee.filter(
                      (w) => {
                        var _;
                        return !((_ = S.standard_concept) != null && _.some(
                          (ae) => ae.value === w.value
                        ));
                      }
                    )) || [],
                    value: S.standard_concept,
                    placeholder: (H = S.standard_concept) != null && H.length ? "" : "Any",
                    multiple: !0,
                    onChange: (w, _) => {
                      C("standard_concept", _);
                    },
                    fullWidth: !0,
                    isOptionEqualToValue: (w, _) => w.value === _,
                    getOptionLabel: en
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(T, { item: !0, xs: 6, children: /* @__PURE__ */ r.jsx(we, { name: "vocabulary", textLabel: "Vocabulary", children: /* @__PURE__ */ r.jsx(
                  Qt,
                  {
                    id: "vocabulary",
                    name: "vocabulary",
                    options: ((I = W == null ? void 0 : W.vocabularies) == null ? void 0 : I.filter(
                      (w) => {
                        var _;
                        return !((_ = S.vocabulary) != null && _.some(
                          (ae) => ae.value === w.value
                        ));
                      }
                    )) || [],
                    value: S.vocabulary,
                    multiple: !0,
                    placeholder: (Ee = S.vocabulary) != null && Ee.length ? "" : "Any",
                    onChange: (w, _) => {
                      C("vocabulary", _);
                    },
                    fullWidth: !0,
                    isOptionEqualToValue: (w, _) => w.value === _,
                    getOptionLabel: en
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(T, { item: !0, xs: 6, sx: { pl: 2 }, children: /* @__PURE__ */ r.jsx(we, { name: "search_precision", textLabel: "Search Precision", children: /* @__PURE__ */ r.jsx(
                  Ns,
                  {
                    value: S.search_precision,
                    onChange: (w) => C("search_precision", w),
                    disabled: E
                  }
                ) }) }),
                /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(Ei, { children: /* @__PURE__ */ r.jsxs(gi, { htmlFor: "suggestion", children: [
                  /* @__PURE__ */ r.jsx(
                    fr,
                    {
                      id: "suggestion",
                      checked: S.suggestion,
                      onChange: (w) => R((_) => ({
                        ..._,
                        suggestion: w.target.checked
                      })),
                      disabled: E,
                      size: "small"
                    }
                  ),
                  "Suggest from external publications"
                ] }) }) }),
                /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsxs(Er, { children: [
                  /* @__PURE__ */ r.jsx(
                    de,
                    {
                      variant: "outlined",
                      disabled: E,
                      onClick: s,
                      startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "deactivate" }),
                      children: "Cancel"
                    }
                  ),
                  /* @__PURE__ */ r.jsx(
                    de,
                    {
                      disabled: E || bt(S.concept_set_name) || bt(S.text),
                      onClick: pe,
                      variant: "contained",
                      color: "success",
                      startIcon: E ? /* @__PURE__ */ r.jsx(ve, { size: 16 }) : /* @__PURE__ */ r.jsx(oe, { iconName: "stars" }),
                      children: l ? "Regenerate" : "Generate"
                    }
                  )
                ] }) })
              ]
            }
          ) }),
          /* @__PURE__ */ r.jsxs(
            bs,
            {
              open: L,
              onClose: G,
              maxWidth: "sm",
              fullWidth: !0,
              children: [
                /* @__PURE__ */ r.jsx(Rs, { children: "Confirm duplicate concept-set handling:" }),
                /* @__PURE__ */ r.jsxs(As, { children: [
                  /* @__PURE__ */ r.jsx(ye, { variant: "body2", color: "text.secondary", sx: { mb: 1.5 }, children: "In case AI generates concept sets that already exist in current Workspace or Study, would you like to" }),
                  /* @__PURE__ */ r.jsxs(ge, { display: "flex", flexDirection: "column", rowGap: 1, children: [
                    /* @__PURE__ */ r.jsxs(ge, { display: "flex", alignItems: "center", columnGap: 0.5, children: [
                      /* @__PURE__ */ r.jsx(
                        At,
                        {
                          checked: y === "NEW_VERSION",
                          onChange: () => g("NEW_VERSION"),
                          name: "generate-conflict-resolution-dialog",
                          size: "small"
                        }
                      ),
                      /* @__PURE__ */ r.jsx(ye, { variant: "subtitle2", children: "OVERWRITE existing Concept Set(s) where possible (recommended)" }),
                      /* @__PURE__ */ r.jsx(mt, { text: mi, children: /* @__PURE__ */ r.jsx(
                        oe,
                        {
                          iconName: "info",
                          sx: { fontSize: 14, color: "text.secondary" }
                        }
                      ) })
                    ] }),
                    /* @__PURE__ */ r.jsxs(ge, { display: "flex", alignItems: "center", columnGap: 0.5, children: [
                      /* @__PURE__ */ r.jsx(
                        At,
                        {
                          checked: y === "NEW_OBJECT",
                          onChange: () => g("NEW_OBJECT"),
                          name: "generate-conflict-resolution-dialog",
                          size: "small"
                        }
                      ),
                      /* @__PURE__ */ r.jsx(ye, { variant: "subtitle2", children: "Create NEW Concept Set(s)" }),
                      /* @__PURE__ */ r.jsx(mt, { text: fi, children: /* @__PURE__ */ r.jsx(
                        oe,
                        {
                          iconName: "info",
                          sx: { fontSize: 14, color: "text.secondary" }
                        }
                      ) })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ r.jsxs(js, { children: [
                  /* @__PURE__ */ r.jsx(
                    de,
                    {
                      variant: "outlined",
                      color: "darkGrey",
                      disabled: E,
                      onClick: G,
                      children: "Cancel"
                    }
                  ),
                  /* @__PURE__ */ r.jsx(
                    de,
                    {
                      variant: "contained",
                      color: "success",
                      disabled: E,
                      onClick: () => {
                        me();
                      },
                      children: l ? "Regenerate" : "Generate"
                    }
                  )
                ] })
              ]
            }
          )
        ]
      }
    );
  }
), Si = ({
  viewMode: e = !1
  //need it for now
}) => {
  const t = Vt(), n = Ir(), { enqueueSnackbar: s } = ot(), a = Ie(
    gt
  ), { openModal: o, closeModal: i } = Ie(He), [l, p] = Z(), [c, d] = Z(!1), f = vr(
    (y) => y.user
  ), E = B(() => {
    var y;
    return (y = f.data.moduleIds) == null ? void 0 : y.includes("ai");
  }, [f]), h = B(() => a == null ? void 0 : a.config, []), x = B(() => In(h.typeContainer, h.parentId), [h.typeContainer, h.parentId]), D = B(() => st(h.typeContainer, h.parentId), [h.typeContainer, h.parentId]), L = () => {
    n(wo(h.typeContainer, h.parentId));
  }, N = () => {
    o(
      () => /* @__PURE__ */ r.jsx(
        _n,
        {
          parentId: h.parentId,
          typeContainer: h.typeContainer,
          createMethod: D,
          onCancel: i,
          afterCreate: (y) => {
            s({
              message: "Concept set created successfully",
              variant: "success"
            }), t(y.id), i(), L();
          }
        }
      ),
      "Add concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  }, M = () => {
    o(
      () => /* @__PURE__ */ r.jsx(
        Jr,
        {
          parentId: h.parentId,
          typeContainer: h.typeContainer,
          createMethod: D,
          onCancel: i,
          onGenerateStart: () => {
            i(), s({
              message: "Concept set generate in progress...",
              variant: "success"
            }), d(!0);
          },
          onGenerateError: () => {
            d(!1);
          },
          afterCreate: (y) => {
            t(`${y.id}`, {
              state: { aiGenerateRequested: !0 }
            }), L();
          }
        }
      ),
      "Generate concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: i
      }
    );
  }, $ = () => {
    o(
      () => /* @__PURE__ */ r.jsx(
        Sn,
        {
          name: "concept-sets",
          currentContainer: h.typeContainer,
          parentId: h.parentId,
          onChange: async () => {
            p(Zs()), i(), L();
          },
          createListMethods: Lt,
          cols: Gt,
          createListFiltersMethod: Mt,
          createMethodCreate: st,
          subModules: a.subModules,
          isSelect: !0,
          hideConflictResolutionMethod: !0,
          hideConflictResolutionControls: !0,
          atlasEntity: [ht.CS],
          successMessage: "Concept set(s) successfully imported.",
          manualImport: !0,
          manualImportComponent: /* @__PURE__ */ r.jsx(
            vn,
            {
              typeContainer: h.typeContainer,
              parentId: h.parentId,
              createMethod: x,
              onChange: (y) => {
                t(y.id), i(), L();
              },
              onClose: i
            }
          )
        }
      ),
      "Import concept set",
      {
        onClose: i,
        closeOnClickOutside: !0
      }
    );
  };
  return c ? /* @__PURE__ */ r.jsx(De, { background: "/images/back.png", children: /* @__PURE__ */ r.jsx(Cr, {}) }) : /* @__PURE__ */ r.jsx(
    Sr,
    {
      reloadId: l,
      isImport: !0,
      onImport: $,
      onCreate: N,
      onGenerate: E && M,
      moduleConfig: a,
      viewMode: e,
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading concept sets...",
        addButtonTitle: "Add concept set",
        tableTitle: "Concept sets",
        moduleDescription: "Concept set is an expression representing a list of vocabulary concepts/codes to define a drug, condition, measurement or other objects that can be used as a reusable component in cohorts and analyses.",
        importButtonTitle: "Import",
        listInitialSort: { id: "modified.timestamp", desc: !0 },
        createCrudMethod: Lt,
        createFiltersPanel: Mt,
        createSortingMethod: aa,
        getCols: ca,
        metadataFilter: "&filter.metadata.subject=CONCEPT_SET",
        extendedSearchEnabled: !1
      },
      variant: "description",
      allowDelete: !0
    }
  );
}, gt = vs(null), xi = (e) => {
  const { path: t, title: n, name: s, rootSettings: a, initStorage: o, viewMode: i } = e, [l, p] = Z(a), [c, d] = Z(!0);
  return J(() => {
    a || p({
      rootPath: t,
      rootTitle: n
    }), d(!1);
  }, []), c ? /* @__PURE__ */ r.jsx(De, { children: /* @__PURE__ */ r.jsx(ve, { size: 32 }) }) : /* @__PURE__ */ r.jsx(gt.Provider, { value: { ...e, rootSettings: l }, children: /* @__PURE__ */ r.jsxs(yr, { children: [
    /* @__PURE__ */ r.jsx(Te, { path: ":id/*", element: /* @__PURE__ */ r.jsx(Kr, {}) }),
    /* @__PURE__ */ r.jsx(Te, { index: !0, element: /* @__PURE__ */ r.jsx(Si, { viewMode: i }) })
  ] }) });
}, yi = (e, t) => ({
  get: (n) => Ft(n),
  delete: (n) => jr(n),
  update: (n, s) => {
    switch (e) {
      case b.STUDY:
        return qo(n, s, t);
      case b.WORKSPACE:
        return Ho(n, s);
      case b.LIBRARY:
        return Zo(s, {
          name: n.name,
          description: n.description
        });
    }
  },
  copy: (n, s, a = te.COPY) => {
    switch (e) {
      case b.STUDY:
        return Pr(t, n, s, a);
      case b.WORKSPACE:
        return wr(n, s, a);
    }
  }
}), Ti = (e, t = 0, n = 0, s, a, o, i, l, p, c, d, f) => {
  var D;
  let E = [
    {
      id: "expression",
      title: /* @__PURE__ */ r.jsx(
        Ae,
        {
          title: "Expression",
          count: ((D = o.expression) == null ? void 0 : D.toLocaleString()) || 0,
          status: P.SUCCESS
        }
      ),
      value: "",
      end: !0
    },
    {
      id: "included-concepts",
      title: /* @__PURE__ */ r.jsx(
        Bt,
        {
          count: t,
          isLoading: l,
          items: a,
          getCount: s,
          versionId: e,
          type: _e.INCLUDED_CONCEPTS
        }
      ),
      value: "included"
    },
    {
      id: "included-source-codes",
      title: /* @__PURE__ */ r.jsx(
        Bt,
        {
          count: n,
          isLoading: i,
          message: "Included source codes",
          items: a,
          getCount: s,
          versionId: e,
          type: _e.INCLUDED_SOURCE_CODES
        }
      ),
      value: "source-codes"
    }
  ];
  c !== b.LIBRARY && E.push({
    id: "versions",
    align: "right",
    iconOnly: !0,
    iconName: "reload",
    title: /* @__PURE__ */ r.jsx(
      Ae,
      {
        title: "Versions",
        count: o.versions || 0,
        status: P.SUCCESS
      }
    ),
    value: "versions"
  }), E.push({
    id: "meta-attributes",
    align: "right",
    iconOnly: !0,
    iconName: "bookmark",
    title: /* @__PURE__ */ r.jsx(
      Ae,
      {
        title: "Metadata",
        count: o.metadata || 0,
        status: P.SUCCESS
      }
    ),
    value: "meta-attributes"
  }), o.metadataAi && E.push({
    id: "ai-meta-attributes",
    align: "right",
    iconOnly: !0,
    iconName: "stars",
    title: /* @__PURE__ */ r.jsx(
      Ae,
      {
        title: "Generative AI",
        count: o.metadataAi || 0,
        status: P.SUCCESS,
        dense: !0
      }
    ),
    value: "ai-meta-attributes"
  }), c !== b.LIBRARY && Number(o.usedIn || 0) > 0 && E.push({
    id: "usage",
    align: "right",
    iconOnly: !0,
    iconName: "users",
    title: /* @__PURE__ */ r.jsx(
      Ae,
      {
        title: "Used In",
        count: o.usedIn || 0,
        status: P.SUCCESS,
        dense: !0
      }
    ),
    value: "usage"
  }), c === b.LIBRARY && !f && E.push({
    id: "statistics",
    align: "right",
    iconOnly: !0,
    iconName: "chart",
    title: /* @__PURE__ */ r.jsx(
      Ae,
      {
        title: "Utilization Statistics",
        count: o.usedIn || 0,
        status: P.SUCCESS,
        dense: !0
      }
    ),
    value: "statistics"
  });
  const h = Number(o.suggestions || 0);
  return !p && (h > 0 || d === et.IN_PROGRESS) && E.push({
    id: "ai-suggested",
    align: "right",
    iconOnly: !0,
    iconName: "aiStars",
    title: /* @__PURE__ */ r.jsx(
      Ae,
      {
        title: "AI suggestions",
        count: h,
        status: d === et.IN_PROGRESS ? P.IN_PROGRESS : P.SUCCESS,
        dense: !0
      }
    ),
    value: "ai-suggested"
  }), E;
}, Ii = "New Concept set", vi = {
  entityBreadcrumbs: (e, t, n, s) => eo(
    Ii,
    e,
    t,
    n,
    s
  ),
  messages: {
    confirmDeleteMessage: "Are you sure you want to delete this concept set?"
  },
  apiMethodsVersioning: {
    getList: Jo,
    getCurrent: kr
  }
}, _i = {
  conceptSet: null,
  conceptSetStatus: P.INITIAL,
  conceptSetError: null,
  countIncludedConcepts: 0,
  countIncludedSourceCodes: 0,
  loadingCountsSourceCodes: !1,
  loadingCountsIncludedConcepts: !1,
  summary: {},
  aiAttrbutes: [],
  aiGenerate: !1,
  aiJobId: null,
  aiStatus: null,
  aiOutput: null,
  aiValues: null,
  aiCompleteTimestamp: null,
  aiCompleteGeneration: !0,
  aiGenerationPending: !1,
  isAiCohort: !1
}, Oi = (e, t) => gn(e, (n) => {
  switch (t.type) {
    case "SET_CONCEPSET":
      n.conceptSetStatus = P.SUCCESS, n.conceptSet = t.payload;
      break;
    case "SAVE_CONCEPT_SET":
      n.conceptSetStatus = P.IN_PROGRESS;
      break;
    case "SAVE_CONCEPT_SET_DONE":
      n.conceptSetStatus = P.SUCCESS;
      break;
    case "SAVE_CONCEPT_SET_ERROR":
      n.conceptSetStatus = P.ERROR;
      break;
    case "UPDATE_CONCEPSET":
      n.conceptSet && (n.conceptSet[t.payload.prop] = t.payload.value);
      break;
    case "ADD_CONCEPTSET_ITEMS":
      if (n.conceptSet) {
        const s = t.payload;
        n.conceptSet.items = {
          ...n.conceptSet.items,
          ...s
        };
      }
      break;
    case "SET_AI_ATTRIBUTES":
      if (n.aiValues = t.payload.aiValues, n.isAiCohort = t.payload.isAiCohort, t.payload.terminalAiStatus) {
        n.aiGenerate = !1, n.aiGenerationPending = !1;
        break;
      }
      t.payload.aiGenerate && (n.aiGenerationPending = !1), n.aiGenerate = t.payload.aiGenerate || n.aiGenerationPending;
      break;
    case "START_GENERATION":
      n.aiGenerate = !0, n.aiGenerationPending = !0;
      break;
    case "SET_AI_RESULTS":
      n.aiStatus = t.payload.aiStatus, n.aiOutput = t.payload.aiOutput, n.aiCompleteTimestamp = t.payload.aiCompleteTimestamp;
      break;
    case "FINISH_GENERATION":
      n.aiCompleteGeneration = !0, n.aiJobId = null;
      break;
    case "SET_COUNT_REQUEST":
      t.payload == _e.INCLUDED_CONCEPTS ? n.loadingCountsIncludedConcepts = !0 : n.loadingCountsSourceCodes = !0;
      break;
    case "SET_COUNT_REQUEST_DONE":
      if (t.payload.reset) {
        n.countIncludedConcepts = 0, n.countIncludedSourceCodes = 0, n.loadingCountsIncludedConcepts = !1, n.loadingCountsSourceCodes = !1;
        break;
      }
      t.payload.typeOfIncluded == _e.INCLUDED_CONCEPTS ? (n.loadingCountsIncludedConcepts = !1, n.countIncludedConcepts = t.payload.count) : (n.loadingCountsSourceCodes = !1, n.countIncludedSourceCodes = t.payload.count);
      break;
    case "GET_SUMMARY":
      n.summary = t.payload;
      break;
  }
}), Ni = (e, t, n) => {
  const s = Ws(e, t, n), [a, o] = fn(
    Oi,
    _i
  ), i = F(async () => {
    try {
      const y = await Xo(t);
      o({
        type: "GET_SUMMARY",
        payload: y
      });
    } catch {
    }
  }, [t]), l = F((y) => {
    o({
      type: "SET_CONCEPSET",
      payload: {
        ...y,
        items: Aa(y.items)
      }
    });
  }, []), p = (y) => {
    o({
      type: "UPDATE_CONCEPTSET_ITEMS",
      payload: y
    });
  }, c = (y) => {
    o({
      type: "ADD_CONCEPTSET_ITEMS",
      payload: y
    });
  }, d = F(
    (y, g) => {
      o({
        type: "UPDATE_CONCEPSET",
        payload: {
          prop: y,
          value: g
        }
      });
    },
    [a.conceptSet]
  ), f = F(
    (y, g) => {
      const v = y || (s == null ? void 0 : s.entity), A = g || (a == null ? void 0 : a.conceptSet);
      if (!(v != null && v.items) || !(A != null && A.items))
        return [];
      const U = {
        items: Ge(v == null ? void 0 : v.items)
      }, Y = {
        items: Ge(A == null ? void 0 : A.items)
      }, ie = Yt(U, Y);
      return zr(ie, Y.items);
    },
    [s.entity, a.conceptSet]
  ), E = async (y) => {
    var Y;
    const g = await Dt(
      "filter.metadata.value.subject.id",
      t
    ), v = g.content.find(nn), A = (Y = g.content.find(to)) == null ? void 0 : Y.value, U = (v == null ? void 0 : v.value) === "Yes" && ["IN_PROGRESS", "QUEUED"].includes(A);
    o({
      type: "SET_AI_ATTRIBUTES",
      payload: {
        aiValues: g.content,
        // Terminal AI events are authoritative even if metadata is briefly stale.
        aiGenerate: y ? !1 : U,
        terminalAiStatus: y,
        isAiCohort: (v == null ? void 0 : v.value) === "Yes"
      }
    });
  }, h = F(() => {
    o({
      type: "START_GENERATION"
      /* START_GENERATION */
    });
  }, []), x = F(
    async (y) => {
      var g, v;
      if ((v = Object.values(((g = a.conceptSet) == null ? void 0 : g.items) || {})) != null && v.length) {
        o({
          type: "SET_COUNT_REQUEST",
          payload: y
        });
        try {
          const A = y == _e.INCLUDED_CONCEPTS ? await Dr(t, {
            delta: f()
          }) : await Lr(t, {
            delta: f()
          });
          o({
            type: "SET_COUNT_REQUEST_DONE",
            payload: {
              typeOfIncluded: y,
              count: A
            }
          });
        } catch {
        }
      } else
        o({
          type: "SET_COUNT_REQUEST_DONE",
          payload: {
            reset: !0
          }
        });
    },
    [s.entity, a.conceptSet]
  ), D = async (y) => {
    await s.getEntity(), await E(y);
  }, L = F(
    (y, g) => {
      var v, A;
      if ((A = Object.values(((v = a.conceptSet) == null ? void 0 : v.items) || {})) != null && A.length)
        try {
          return Mr(g, y, t, {
            delta: f()
          });
        } catch (U) {
          console.error("Error fetching included concepts:", U);
        }
      else
        return o({
          type: "SET_COUNT_REQUEST_DONE",
          payload: {
            reset: !0
          }
        }), Promise.resolve(null);
    },
    [s.entity, a.conceptSet]
  ), N = F(
    (y, g) => {
      const v = f();
      try {
        return Ur(g, y, t, {
          delta: v
        });
      } catch (A) {
        console.error("Error fetching included concepts filters:", A);
      }
    },
    [s.entity, a.conceptSet]
  ), M = F(
    async (y) => {
      o({
        type: "SAVE_CONCEPT_SET"
        /* SAVE_CONCEPT_SET */
      });
      const g = {
        ...a.conceptSet,
        name: y.name,
        description: y.description,
        delta: f()
      };
      try {
        await s.updateEntity(g), await i();
      } catch {
        o({
          type: "SAVE_CONCEPT_SET_ERROR"
          /* SAVE_CONCEPT_SET_ERROR */
        });
      }
    },
    [a.conceptSet]
  ), $ = B(() => !!(s.status !== P.SUCCESS || a.conceptSetStatus !== P.SUCCESS || f().length === 0 && Pt(s.entity.name, a.conceptSet.name) && Pt(s.entity.description, a.conceptSet.description)), [
    s.status,
    a.conceptSetStatus,
    s.entity,
    a.conceptSet
  ]);
  return J(() => {
    s.status === P.SUCCESS && (async () => (await E(), await i(), l(s.draft)))();
  }, [s.draft]), {
    ...a,
    ...s,
    updateDesign: d,
    submitEntity: M,
    getCountIncluded: x,
    setDesign: l,
    getIncludedConcepts: L,
    getIncludedConceptsFilters: N,
    addConceptSetItemsBulk: c,
    isEqual: $,
    getCountsSummary: i,
    refetchEntity: D,
    startGeneration: h,
    updateConceptSetItemsBulk: p,
    getItemsDelta: f,
    isLoadingAi: a.aiGenerate && (a.aiStatus === "PROCESSING" || !a.aiCompleteGeneration)
  };
}, pr = ({}) => {
  const { id: e } = Tr(), { status: t, state: n } = Vs(Br, e), s = no(n);
  return /* @__PURE__ */ r.jsx(xo, { board: s == null ? void 0 : s.board, status: t, list: s == null ? void 0 : s.list });
}, bi = (e) => {
  const { id: t, typeContainer: n, parentId: s } = e, a = Vt(), { closeModal: o } = Ie(He), i = Ie(
    gt
  );
  return /* @__PURE__ */ r.jsx(
    Sr,
    {
      isImport: !1,
      isEnableMetadata: !0,
      moduleConfig: i,
      uniqName: "Usage",
      onRowClick: (l) => {
        var c, d, f;
        const p = ia(
          l.original.id,
          l.original.type,
          l.original.supertype,
          n,
          s
        );
        if ((d = (c = i == null ? void 0 : i.config) == null ? void 0 : c.onCancel) == null || d.call(c), o(), window.dispatchEvent(new Event("prometheus:close-modal")), (f = i == null ? void 0 : i.config) != null && f.saveOnlyActions) {
          window.location.assign(p);
          return;
        }
        a(p);
      },
      listConfig: {
        rowId: "id",
        loadingMessage: "Loading Used In references...",
        tableTitle: "Used In",
        moduleDescription: "",
        listInitialSort: { id: "name", desc: !1 },
        addButtonTitle: null,
        createCrudMethod: () => ({
          fetch: (l, p, c, d) => Ar(t, {
            pageNumber: l,
            pageSize: p,
            sortBy: c,
            query: d
          })
        }),
        createFiltersPanel: () => ({
          getFilters: (l) => Yo(l, t),
          formatFilters: ro
        }),
        createSortingMethod: () => () => Vo(t),
        cols: da
      },
      variant: "no-header",
      pinnedColumns: { left: ["type", "name"], right: [] },
      dense: !0
    }
  );
}, Kr = ({
  entityId: e,
  onEntityReady: t,
  onEntitySaved: n,
  saveOnlyActions: s = !1
}) => {
  var Hn;
  const { id: a } = Tr(), o = e || a, i = Ir(), l = Vt(), p = xr(), [c, d] = Z(null), [f, E] = Z(""), [h, x] = Z(0), [D, L] = Z(!1), [N] = Ro(), M = so(N.get("typePublish")), $ = !!((Hn = p.state) != null && Hn.aiGenerateRequested), { rootSettings: y, path: g, title: v, config: A, subModules: U } = Ie(
    gt
  ), { showDialog: Y, hideDialog: ie } = Ie(Fs), { enqueueSnackbar: K } = ot(), { openModal: S, closeModal: R } = Ie(He), { rootPath: q, rootTitle: W } = y, { parentId: Q, parentTitle: he, typeContainer: V } = A, ue = V !== b.LIBRARY, { messages: C, entityBreadcrumbs: j, apiMethodsVersioning: z } = vi, G = N.get("from") === b.LIBRARY && !!N.get("typePublish"), me = B(() => yi(V, Q), [Q]), pe = B(() => st(A.typeContainer, A.parentId), [A.typeContainer, A.parentId]), u = vr(
    (m) => {
      var X;
      return ((X = m.user.data.moduleIds) == null ? void 0 : X.includes("ai")) ?? !1;
    }
  ), { start: ne, stop: ee, status: H } = zs(), {
    entity: I,
    aiGenerate: Ee,
    addConceptSetItemsBulk: w,
    submitEntity: _,
    refetchEntity: ae,
    startGeneration: fe,
    aiValues: ce,
    actions: re,
    updateEntity: Je,
    isVersionMode: le,
    status: Oe,
    error: St,
    conceptSet: O,
    version: Ht,
    conceptSetStatus: Ke,
    setVersionEntity: Qr,
    revertEntity: Xr,
    deleteEntity: Zr,
    copyEntity: es,
    countIncludedConcepts: Rn,
    countIncludedSourceCodes: An,
    loadingCountsSourceCodes: jn,
    loadingCountsIncludedConcepts: wn,
    getIncludedConcepts: Pn,
    getIncludedConceptsFilters: Dn,
    getCountIncluded: ts,
    isAiCohort: ns,
    clearConceptSetLogItems: rs,
    isEqual: ss,
    summary: at,
    getCountsSummary: Qe,
    updateDesign: qt,
    getItemsDelta: Ln
  } = Ni(me, o, "Concept set"), Mn = yo(), Un = B(() => V === b.LIBRARY ? Mn : !!(re != null && re["update.metadata"] || re != null && re[Ao.UPDATE]), [re, Mn, V]);
  J(() => {
    $ && (fe(), l(
      {
        pathname: p.pathname,
        search: p.search,
        hash: p.hash
      },
      { replace: !0, state: null }
    ));
  }, [
    $,
    p.hash,
    p.pathname,
    p.search,
    l,
    fe
  ]);
  const it = B(() => {
    const X = (ce == null ? void 0 : ce.some(nn)) ? 1 : 0, be = (ce == null ? void 0 : ce.filter(
      (Re) => oo(Re) && !nn(Re)
    ).length) || 0;
    return {
      ...at,
      metadata: (at.metadata || 0) + X,
      "metadata-ai": Math.max(
        (at["metadata-ai"] || 0) - X,
        be
      )
    };
  }, [ce, at]), os = () => {
    S(
      () => /* @__PURE__ */ r.jsx(
        Oo,
        {
          propId: "conceptSetId",
          onClose: R,
          item: I,
          inviteMethod: Ko
        }
      ),
      "Publish concept set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: R
      }
    );
  }, as = (m) => {
    S(
      () => /* @__PURE__ */ r.jsx(
        U.cohort,
        {
          type: "component",
          name: "create-cohort-from-concept-set",
          subModules: U,
          config: {
            onCancel: R,
            entity: I,
            parentId: Q,
            typeContainer: V
          }
        }
      ),
      m.name,
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: R
      }
    );
  }, is = () => {
    S(
      () => /* @__PURE__ */ r.jsx(
        gr,
        {
          id: I.id,
          name: O.name,
          parentId: Q,
          currentContainer: V,
          subModules: U,
          jsonImportTabName: "Concept Set Items",
          createCopyMethod: Fr,
          typeEntity: "concept-sets",
          entityAtlas: ht.CS,
          defaultResolution: te.CREATE_NEW_OBJECT,
          hideConflictResolutionControls: !0,
          validateName: async (m) => m.typeContainer === b.WORKSPACE ? ze(
            b.WORKSPACE,
            m.name
          ) : m.typeContainer === b.STUDY ? m.studyId ? ze(
            b.STUDY,
            m.name,
            String(m.studyId)
          ) : {
            isValid: !1,
            message: "Study is required."
          } : { isValid: !0 },
          onChange: () => {
            R();
          },
          exportJson: /* @__PURE__ */ r.jsx(qr, { id: O.id, title: O.name }),
          customAction: /* @__PURE__ */ r.jsx(
            "a",
            {
              href: `/api/conceptset/${I.id}/included/csv-zip`,
              target: "_blank",
              children: /* @__PURE__ */ r.jsx(
                de,
                {
                  variant: "contained",
                  color: "success",
                  size: "small",
                  startIcon: /* @__PURE__ */ r.jsx(oe, { iconName: "export" }),
                  children: "Export to CSV"
                }
              )
            }
          )
        }
      ),
      "Export concept set",
      {
        closeOnClickOutside: !0,
        onClose: R
      }
    );
  }, cs = !!(re["update.name"] || re["update.description"]), Ue = !(re != null && re[jo.UPDATE]), Jt = B(() => {
    var m;
    return Ti(
      O == null ? void 0 : O.versionId,
      Rn,
      An,
      ts,
      O == null ? void 0 : O.items,
      {
        expression: (m = Object.values((O == null ? void 0 : O.items) || {})) == null ? void 0 : m.length,
        versions: it.versions,
        metadata: it.metadata,
        metadataAi: it["metadata-ai"],
        usedIn: h,
        suggestions: it.suggestions
      },
      jn,
      wn,
      Ue,
      V,
      c,
      G
    );
  }, [
    o,
    g,
    N,
    jn,
    wn,
    Rn,
    An,
    O == null ? void 0 : O.versionId,
    V,
    O == null ? void 0 : O.items,
    it,
    h,
    c,
    G
  ]), xt = B(
    () => [
      "included",
      "source-codes",
      ...ue ? ["versions"] : [],
      "meta-attributes",
      "ai-meta-attributes",
      "ai-suggested",
      "usage",
      ...G ? [] : ["statistics"]
    ],
    [ue, G]
  ), Xe = B(
    () => (p.pathname.split("/modal")[0] || p.pathname).replace(
      /\/+$/,
      ""
    ) || "/",
    [p.pathname]
  ), Ne = B(() => s ? xt.find(
    (m) => Xe.endsWith(`/${m}`)
  ) || "expression" : "", [Xe, xt, s]), Ze = B(() => {
    if (!s)
      return "";
    const m = xt.find(
      (X) => Xe.endsWith(`/${X}`)
    );
    return m ? Xe.slice(0, -`/${m}`.length) || "/" : Xe;
  }, [Xe, xt, s]), ct = B(
    () => Ze.replace(/^\/+/, ""),
    [Ze]
  ), ls = B(() => {
    if (!s)
      return Jt;
    const m = Ze || "/";
    return Jt.map((X) => {
      const be = String(X.value || "");
      return be ? be.startsWith("/") ? X : {
        ...X,
        value: m === "/" ? `/${be}` : `${m}/${be}`
      } : {
        ...X,
        value: m
      };
    });
  }, [Ze, s, Jt]), yt = F(() => {
    if (s) {
      l(`${Ze}${p.search || ""}`);
      return;
    }
    l(`/${g}/${o}`);
  }, [Ze, o, p.search, l, g, s]), Tt = (I == null ? void 0 : I.id) ?? o, ds = s ? ct : `${g}/${Tt}`, us = s ? `${ct}/included` : `${g}/${Tt}/included`, ps = s ? `${ct}/source-codes` : `${g}/${Tt}/source-codes`, ms = s ? `${ct}/ai-suggested` : `${g}/${Tt}/ai-suggested`, kn = B(() => Ln(), [Ln]), fs = B(
    () => ({
      concepts: O == null ? void 0 : O.items,
      onChange: w,
      onFinish: () => {
        yt();
      },
      viewMode: Ue,
      parentId: Q,
      typeContainer: V,
      conceptSetId: o,
      suggestionStatus: c,
      delta: kn
    }),
    [
      O == null ? void 0 : O.items,
      w,
      yt,
      Ue,
      Q,
      V,
      c,
      kn
    ]
  ), Cs = () => {
    Y(No, {
      onSubmit: async () => {
        try {
          await Zr(), l(`/${g}`);
        } catch {
        }
      },
      onClose: ie,
      text: C.confirmDeleteMessage,
      confirmButtonText: "DELETE",
      variant: "error"
    });
  }, hs = To(
    I == null ? void 0 : I.id,
    V === b.LIBRARY,
    g
  ), Es = F(() => {
    try {
      i(
        Po("conceptSets", {
          ...le ? { ...Ht, versionId: Ht.revertVersionId } : I,
          parentId: Q,
          typeContainer: V
        })
      ), K({
        message: `Concept set ${I.name} has been added to comparison`,
        variant: "success"
      });
    } catch (m) {
      console.error(m), K({
        message: "Oops! Something went wrong",
        variant: "error"
      });
    }
  }, [at, I, le, Ht, Q]), gs = F(
    async (m) => {
      if ((m == null ? void 0 : m.name) !== (I == null ? void 0 : I.name) && V !== b.LIBRARY) {
        const Re = await ze(
          V,
          m.name,
          Q,
          I == null ? void 0 : I.id
        );
        if (!Re.isValid) {
          E(Re.message || "");
          return;
        }
      }
      E(""), L(!0), await _(m);
    },
    [I == null ? void 0 : I.id, I == null ? void 0 : I.name, Q, _, V]
  );
  J(() => {
    if (!D)
      return;
    if (Ke === P.ERROR) {
      L(!1);
      return;
    }
    if (Ke !== P.SUCCESS || Oe !== P.SUCCESS)
      return;
    const m = I || O;
    m && (n == null || n({
      id: m == null ? void 0 : m.id,
      name: m == null ? void 0 : m.name,
      versionId: m == null ? void 0 : m.versionId,
      versionOrdinal: m == null ? void 0 : m.versionOrdinal,
      version: m == null ? void 0 : m.version,
      currentVersionId: (m == null ? void 0 : m.currentVersionId) ?? (m == null ? void 0 : m.versionId),
      currentVersionOrdinal: (m == null ? void 0 : m.currentVersionOrdinal) ?? (m == null ? void 0 : m.versionOrdinal) ?? (m == null ? void 0 : m.version)
    })), L(!1);
  }, [
    O,
    Ke,
    I,
    D,
    n,
    Oe
  ]);
  const Ss = () => {
    var X;
    const m = (X = ce == null ? void 0 : ce.find(
      (be) => {
        var Re;
        return ((Re = be.attribute) == null ? void 0 : Re.name) == "ai-prompt";
      }
    )) == null ? void 0 : X.value;
    S(
      () => /* @__PURE__ */ r.jsx(
        Jr,
        {
          parentId: A.parentId,
          typeContainer: A.typeContainer,
          entity: I,
          prompt: m,
          attributes: ce ?? void 0,
          createMethod: pe,
          onCancel: R,
          onGenerateStart: () => {
            fe(), R(), K({
              message: "Concept set regenerate in progress...",
              variant: "success"
            });
          },
          onGenerateError: () => {
            ae();
          },
          afterCreate: async () => {
            await ae(), await Qe();
          }
        }
      ),
      "Regenerate Concept Set",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: R
      }
    );
  }, xs = V === b.LIBRARY && N.get("from") !== b.LIBRARY, ys = () => {
    S(
      () => /* @__PURE__ */ r.jsx(
        U.users,
        {
          type: "component",
          name: "share-entity",
          subModules: U,
          config: {
            ...A,
            entity: I,
            entityType: "Concept Set",
            onClose: R,
            onChange: R
          }
        }
      ),
      "Share Concept Set",
      {
        closeOnClickOutside: !0,
        onClose: R,
        width: "700px"
      }
    );
  }, Ts = () => {
    S(
      () => /* @__PURE__ */ r.jsx(
        U.vocabulary,
        {
          type: "component",
          name: "ai-suggest-dialog",
          subModules: U,
          config: {
            entity: I,
            entityType: "Concept Set",
            onClose: () => {
              R();
            },
            onFinish: () => {
              Is(), d(et.IN_PROGRESS), l("ai-suggested");
            },
            conceptSetId: o,
            suggestionStatus: c
          }
        }
      ),
      "Suggest from external publications",
      {
        closeOnClickOutside: !0,
        onClose: R,
        width: "700px"
      }
    );
  }, Is = Gs(
    () => sr(o).then((m) => d((m == null ? void 0 : m.status) || null)).catch(console.error),
    () => c === et.DONE || c === et.ERROR || c == null,
    1e4
  );
  J(() => {
    O != null && O.id && Ee && ne({
      subjectId: O == null ? void 0 : O.id
    });
  }, [Ee, O == null ? void 0 : O.id]), J(() => () => ee(), []), J(() => {
    let m;
    return ["DONE", "ERROR"].includes(H) && (m = setTimeout(() => {
      ae(H), ee();
    }, 3e3)), () => clearTimeout(m);
  }, [H]), J(() => {
    i(
      Do(
        j(o, I == null ? void 0 : I.name, {
          path: (M == null ? void 0 : M.path) || g,
          title: (M == null ? void 0 : M.title) || v,
          rootPath: q,
          rootTitle: W,
          parentTitle: he,
          parentId: Q
        })
      )
    );
  }, [g, I]), J(() => {
    o && sr(o).then((m) => d((m == null ? void 0 : m.status) || null)).catch(console.error);
  }, [o]), J(() => {
    c === et.DONE && Qe();
  }, [c]), J(() => {
    if (!o || o === "new") {
      x(0);
      return;
    }
    if (V === b.LIBRARY) {
      Br(o).then((m) => x(ao(m))).catch(() => x(0));
      return;
    }
    Ar(o, {
      pageNumber: 0,
      pageSize: 1,
      sortBy: {
        id: "name",
        desc: !1
      },
      query: ""
    }).then((m) => {
      const X = Number(
        (m == null ? void 0 : m.totalElements) ?? (m == null ? void 0 : m.numberOfElements) ?? (Array.isArray(m == null ? void 0 : m.content) ? m.content.length : 0)
      );
      x(Number.isNaN(X) ? 0 : X);
    }).catch(() => x(0));
  }, [o, V]), J(() => {
    document.title = "Prometheus - " + W + " - Concept sets";
  }, [W]);
  const Kt = [P.INITIAL, P.IN_PROGRESS].includes(Oe) || [P.INITIAL].includes(Ke) || Ee || $;
  if (J(() => {
    Kt || t == null || t();
  }, [Kt, t]), Oe === P.ERROR)
    return /* @__PURE__ */ r.jsx(De, { children: /* @__PURE__ */ r.jsx(Kn, { ...St.response, path: g }) });
  if (Kt) {
    const m = Ee || $;
    return /* @__PURE__ */ r.jsx(
      De,
      {
        background: m && "/images/back.png",
        children: m ? /* @__PURE__ */ r.jsx(Cr, {}) : /* @__PURE__ */ r.jsx(ve, { size: 62 })
      }
    );
  }
  if (!s && o !== "new" && !(I != null && I.id))
    return /* @__PURE__ */ r.jsx(De, { children: /* @__PURE__ */ r.jsx(
      Kn,
      {
        status: 404,
        statusText: "Not Found",
        message: "Concept set not found",
        data: null,
        path: g
      }
    ) });
  const $n = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
    U.vocabulary,
    {
      type: "component",
      name: "included-concepts",
      path: us,
      subModules: U,
      config: {
        concepts: [],
        methodIncluded: Pn,
        filtersIncluded: Dn,
        onChange: w,
        conceptSetId: O == null ? void 0 : O.id,
        versionId: O == null ? void 0 : O.versionId,
        onFinish: yt,
        viewMode: Ue,
        outlined: !0
      }
    }
  ) }) }), Bn = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(T, { item: !0, xs: 12, children: /* @__PURE__ */ r.jsx(
    U.vocabulary,
    {
      type: "component",
      name: "included-concepts-source-codes",
      path: ps,
      subModules: U,
      config: {
        concepts: [],
        methodIncluded: Pn,
        filtersIncluded: Dn,
        onChange: w,
        conceptSetId: O == null ? void 0 : O.id,
        versionId: O == null ? void 0 : O.versionId,
        onFinish: yt,
        viewMode: Ue
      }
    }
  ) }) }), Wn = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(
    Io,
    {
      data: O,
      path: s ? ct : g,
      makeCopy: () => {
      },
      setPreviewEntity: Qr,
      apiMethods: z,
      originVersionId: I.versionId
    }
  ) }), Vn = /* @__PURE__ */ r.jsx(
    Qn,
    {
      id: I.id,
      name: I.name,
      metadataSubject: Rt.CONCEPT_SET,
      canUpdate: Un,
      initialTypeContainer: V,
      initialParentId: Q,
      initialParentName: he,
      title: "Concept set",
      url: "conceptset",
      getBaseUrl: (m, X) => {
        switch (m) {
          case b.WORKSPACE:
            return "/workspace/concept-sets/";
          case b.STUDY:
            return `/studies/${X}/concept-sets/`;
          default:
            return "/concept-sets/";
        }
      },
      configMetadataValuesApi: {
        entityFilter: "subject",
        getListValues: Dt,
        updateMetadataValue: an,
        removeMetadataValue: rr,
        createMetadataValue: on,
        copyMetadataValue: nr
      },
      callback: () => {
        Qe();
      }
    }
  ), Fn = /* @__PURE__ */ r.jsx(
    Qn,
    {
      id: I.id,
      name: I.name,
      aiMode: !0,
      metadataSubject: Rt.CONCEPT_SET,
      canUpdate: Un,
      initialTypeContainer: V,
      initialParentId: Q,
      initialParentName: he,
      title: "Concept set",
      url: "conceptset",
      getBaseUrl: (m, X) => {
        switch (m) {
          case b.WORKSPACE:
            return "/workspace/concept-sets/";
          case b.STUDY:
            return `/studies/${X}/concept-sets/`;
          default:
            return "/concept-sets/";
        }
      },
      configMetadataValuesApi: {
        entityFilter: "subject",
        getListValues: Dt,
        updateMetadataValue: an,
        removeMetadataValue: rr,
        createMetadataValue: on,
        copyMetadataValue: nr
      },
      callback: () => {
        Qe();
      }
    },
    `${I.id}-aimetadata`
  ), zn = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(
    U.vocabulary,
    {
      type: "component",
      name: "ai-suggested-concepts",
      path: ms,
      subModules: U,
      config: fs
    }
  ) }), Gn = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(Wt, { outlined: !0, children: /* @__PURE__ */ r.jsx(
    bi,
    {
      id: I.id,
      typeContainer: V,
      parentId: Q
    }
  ) }) }), Yn = /* @__PURE__ */ r.jsx(Be, { children: /* @__PURE__ */ r.jsx(
    U.vocabulary,
    {
      type: "component",
      name: "expression-concepts",
      path: ds,
      subModules: U,
      config: {
        concepts: O == null ? void 0 : O.items,
        onChange: (m) => {
          qt("items", m);
        },
        viewMode: Ue,
        parentId: Q,
        typeContainer: V,
        mode: "stand-alone"
      }
    }
  ) });
  return /* @__PURE__ */ r.jsxs(T, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ r.jsx(vo, { children: /* @__PURE__ */ r.jsx(
      _o,
      {
        entity: le || V !== b.LIBRARY ? O : I,
        onDelete: Cs,
        disableSave: Oe !== P.SUCCESS || Ke !== P.SUCCESS || ss,
        saveInProgress: Ke,
        onExport: is,
        onSubmit: async (m) => {
          await gs(m);
        },
        onChange: V !== b.LIBRARY ? (m) => {
          qt("name", m.name), qt("description", m.description);
        } : void 0,
        onClickExtraActions: (m) => {
          as(m);
        },
        onCompare: Es,
        onArchive: hs,
        onGenerate: u && ns && V != b.LIBRARY ? Ss : null,
        onPublish: os,
        onCopy: async (m) => {
          const X = await es(O);
          X != null && X.id && (l(`/${g}/${X.id}`, { replace: !0 }), Qe());
        },
        versionPreview: le,
        onVersionRevert: Xr,
        onVersionSave: function() {
          Je({
            ...O,
            name: O.originName
          }), rs(), Qe();
        },
        viewMode: Ue,
        libraryMode: cs,
        backToListPath: G ? "../../" : "",
        AdditionalActions: G && /* @__PURE__ */ r.jsx(
          U.library,
          {
            type: "component",
            name: "answer-publish-widget",
            subModules: U,
            config: {
              ...A,
              type: N.get("typePublish"),
              typeEntity: Rt.CONCEPT_SET,
              nameEntity: O == null ? void 0 : O.name,
              id: N.get("id"),
              isRedirect: !0,
              requestStatus: N.get("status")
            }
          }
        ),
        shareable: xs,
        onShare: ys,
        onSuggest: u ? Ts : void 0,
        suggestionStatus: c,
        nameError: f,
        saveOnlyActions: s
      }
    ) }),
    /* @__PURE__ */ r.jsxs(T, { item: !0, xs: 12, children: [
      /* @__PURE__ */ r.jsx(
        xn,
        {
          tabs: ls,
          withRouting: !0,
          secondary: !0
        }
      ),
      /* @__PURE__ */ r.jsx(En, {})
    ] }),
    /* @__PURE__ */ r.jsx(T, { container: !0, item: !0, xs: 12, py: 3, children: s ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      Ne === "included" && $n,
      Ne === "source-codes" && Bn,
      Ne === "versions" && ue && Wn,
      Ne === "meta-attributes" && Vn,
      Ne === "ai-meta-attributes" && Fn,
      Ne === "ai-suggested" && zn,
      Ne === "usage" && Gn,
      Ne === "statistics" && !G && /* @__PURE__ */ r.jsx(pr, {}),
      Ne === "expression" && Yn
    ] }) : /* @__PURE__ */ r.jsxs(yr, { children: [
      /* @__PURE__ */ r.jsx(Te, { path: "included/*", element: $n }),
      /* @__PURE__ */ r.jsx(Te, { path: "source-codes/*", element: Bn }),
      /* @__PURE__ */ r.jsx(
        Te,
        {
          path: "versions",
          element: ue ? Wn : /* @__PURE__ */ r.jsx(Xn, { to: "..", replace: !0 })
        }
      ),
      /* @__PURE__ */ r.jsx(Te, { path: "meta-attributes", element: Vn }),
      /* @__PURE__ */ r.jsx(
        Te,
        {
          path: "ai-meta-attributes",
          element: Fn
        }
      ),
      /* @__PURE__ */ r.jsx(Te, { path: "ai-suggested", element: zn }),
      /* @__PURE__ */ r.jsx(Te, { path: "usage", element: Gn }),
      /* @__PURE__ */ r.jsx(Te, { path: "*", element: Yn }),
      /* @__PURE__ */ r.jsx(
        Te,
        {
          path: "statistics",
          element: G ? /* @__PURE__ */ r.jsx(Xn, { to: "..", replace: !0 }) : /* @__PURE__ */ r.jsx(pr, {})
        }
      )
    ] }) })
  ] });
}, Ri = Me((e) => {
  const { name: t, config: n, ...s } = e, {
    onChange: a,
    values: o,
    conceptSets: i,
    defaultValue: l,
    conceptSet: p,
    onUpdate: c,
    onClear: d,
    concepts: f,
    onSave: E,
    onCancel: h,
    component: x,
    conceptSetId: D,
    fastMarker: L,
    viewMode: N,
    titleText: M,
    description: $,
    buttonText: y,
    returnEntityText: g,
    isSelect: v,
    entityType: A,
    initialData: U,
    initialDataByValue: Y,
    simpleButtonMode: ie,
    localImport: K,
    embeddedReferenceOnly: S,
    isDark: R,
    typeContainer: q,
    parentId: W,
    analysisMode: Q,
    withAlias: he,
    disableActions: V = !1,
    exportConceptSet: ue,
    circleMode: C,
    hideSectionContent: j,
    conceptSetNameErrors: z,
    onConceptSetNameSubmit: G,
    onConceptSetNameCancel: me,
    refreshConceptSetReference: pe,
    renderSectionTitleAddon: u,
    onEditSection: ne,
    onConceptSetEntityReady: ee,
    onConceptSetEntitySaved: H,
    onAddConceptSet: I,
    hideAddConceptSetAction: Ee,
    hideCopySectionAction: w,
    hideEditSectionAction: _,
    saveOnlyActions: ae
  } = n, fe = q || b.WORKSPACE, ce = st(
    fe,
    W
  );
  return /* @__PURE__ */ r.jsxs(mn.Fragment, { children: [
    t === "widget-concept-set-import-button" && /* @__PURE__ */ r.jsx(
      Ta,
      {
        ...s,
        titleText: M,
        buttonText: y,
        returnEntityText: g,
        typeContainer: q,
        parentId: W,
        isSelect: v,
        entityType: A,
        onChange: a,
        initialData: U,
        initialDataByValue: Y,
        description: $,
        withAlias: he
      }
    ),
    t === "widget-concept-set-save" && /* @__PURE__ */ r.jsx(
      Xa,
      {
        ...s,
        concepts: f,
        onSave: E,
        onCancel: h,
        component: x,
        typeContainer: q,
        parentId: W,
        disableActions: V
      }
    ),
    t === "widget-concept-set-choose-button" && /* @__PURE__ */ r.jsx(
      Vr,
      {
        ...s,
        conceptSets: i,
        defaultValue: l,
        onUpdate: c,
        onClear: d,
        conceptSetId: D,
        typeContainer: q,
        parentId: W,
        simpleButtonMode: ie,
        localImport: K,
        embeddedReferenceOnly: S
      }
    ),
    t === "view-concept-set-button" && /* @__PURE__ */ r.jsx(
      di,
      {
        ...s,
        conceptSets: i,
        conceptSetId: D
      }
    ),
    t === "concept-set-form" && ce && /* @__PURE__ */ r.jsx(
      _n,
      {
        parentId: W,
        typeContainer: fe,
        createMethod: ce,
        onCancel: () => h == null ? void 0 : h(),
        afterCreate: (re) => E == null ? void 0 : E(re)
      }
    ),
    t === "concept-set-sections-widget-new" && /* @__PURE__ */ r.jsx(
      li,
      {
        ...s,
        conceptSets: i,
        onChange: a,
        viewMode: N,
        typeContainer: q,
        parentId: W,
        analysisMode: Q,
        exportConceptSet: ue,
        circleMode: C,
        hideSectionContent: j,
        conceptSetNameErrors: z,
        onConceptSetNameSubmit: G,
        onConceptSetNameCancel: me,
        refreshConceptSetReference: pe,
        renderSectionTitleAddon: u,
        onEditSection: ne,
        onAddConceptSet: I,
        hideAddConceptSetAction: Ee,
        hideCopySectionAction: w,
        hideEditSectionAction: _
      }
    ),
    t === "concept-set-entity-embedded" && /* @__PURE__ */ r.jsx(
      gt.Provider,
      {
        value: {
          ...e,
          rootSettings: e.rootSettings || {
            rootPath: e.path || "workspace/concept-sets",
            rootTitle: e.title || "Concept sets"
          }
        },
        children: /* @__PURE__ */ r.jsx(
          Kr,
          {
            entityId: D,
            onEntityReady: ee,
            onEntitySaved: H,
            saveOnlyActions: ae
          }
        )
      }
    ),
    t === "home-widget-concept-set" && /* @__PURE__ */ r.jsx(_a, {})
  ] });
}), Wi = (e) => {
  const { type: t } = e;
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    !t && /* @__PURE__ */ r.jsx(xi, { ...e }),
    t === "component" && /* @__PURE__ */ r.jsx(Ri, { ...e })
  ] });
};
export {
  Wi as ConceptSet
};
//# sourceMappingURL=concept-sets.js.map
